import { Resources } from '../interface/products.model';
import { ResourceItem } from '../interface/resources.model';

export const resourcesList: Resources[] = [
  {
    name: 'Brochures',
    title: 'IT Product Brochures & Solution Guides | Infraon',
    description:
      'Download Infraon brochures to explore ITSM, ITAM, AIOps, network monitoring, OSS, IMS, NCCM, and enterprise IT solutions.',
    logo: '/assets/img/thumbnails/filters/brochure.svg',
    slug: 'brochures',
    link: 'resources/brochures',
  },
  {
    name: 'Presentations',
    title: 'IT Solution Presentations | Infraon',
    description:
      "Explore presentations highlighting Infraon's ITSM, ITAM, AIOps, infrastructure monitoring, and enterprise IT solutions.",
    logo: '/assets/img/thumbnails/filters/ppt.svg',
    slug: 'presentations',
    link: 'resources/presentations',
  },
  {
    name: 'Case Studies',
    title: 'IT Case Studies & Customer Success Stories | Infraon',
    description:
      'Discover real-world customer success stories showcasing how organizations use Infraon to improve ITSM, ITAM, AIOps, network monitoring, automation, and enterprise IT operations.',
    logo: '/assets/img/thumbnails/filters/case-study.svg',
    slug: 'case-studies',
    link: 'resources/case-studies',
  },
  {
    name: 'Webinars',
    title: 'IT Webinars & On-Demand Sessions | Infraon',
    description:
      'Watch on-demand webinars featuring ITSM, ITAM, AIOps, compliance, automation, and enterprise IT best practices.',
    logo: '/assets/img/thumbnails/filters/webinar.svg',
    slug: 'webinars',
    link: 'resources/webinars',
  },
  {
    name: 'Press and Media',
    title: 'Infraon News, Press Releases & Media Coverage | Infraon',
    description:
      'Stay up to date with the latest Infraon announcements, product launches, industry news, media coverage, and company updates.',
    logo: '/assets/img/thumbnails/filters/pr.svg',
    slug: 'press-n-medias',
    link: 'resources/press-n-medias',
  },
  {
    name: 'Whitepapers',
    title: 'Expert IT Whitepapers & Insights | Infraon',
    description:
      'Read expert whitepapers covering ITSM, ITAM, FinOps, AIOps, IT automation, and enterprise infrastructure management.',
    logo: '/assets/img/thumbnails/filters/whitepapers.svg',
    slug: 'whitepapers',
    link: 'resources/whitepapers',
  },
  {
    name: 'EBooks',
    title: 'Comprehensive IT E-Books & Guides | Infraon',
    description:
      'Explore comprehensive e-books on ITSM, AIOps, ITAM, digital transformation, and modern IT operations best practices.',
    logo: '/assets/img/thumbnails/filters/ebook.svg',
    slug: 'ebook',
    link: 'resources/ebook',
  },
  {
    name: 'Datasheet',
    title: 'IT Product Datasheets & Technical Specifications | Infraon',
    description:
      "Access technical datasheets for Infraon's IT operations solutions, features, integrations, and deployment capabilities.",
    logo: '/assets/img/thumbnails/filters/datasheet.svg',
    slug: 'datasheet',
    link: 'resources/datasheet',
  },
  {
    name: 'Free Resources',
    title: 'Free IT Templates, Calculators & Resources | Infraon',
    description:
      'Access free IT templates, calculators, guides, and practical resources to improve IT operations, asset management, and service delivery.',
    logo: '/assets/img/thumbnails/filters/free-resources.svg',
    slug: 'free-resources',
    link: 'resources/free-resources',
  },
];

export const resourcesDocs: ResourceItem[] = [
  // brochures
  {
    id: 1,
    slug: 'infraon-assets',
    title: 'Infraon Assets',
    product: 'Infraon Assets',
    subtitle: 'A Fully Integrated Asset Management',
    description:
      'Complete IT asset management software for hardware, software, and license tracking across enterprises. Automate discovery in 48-72 hours, optimize costs by 30%, eliminate spreadsheet chaos, and achieve compliance with real-time visibility.',
    topics: [
      'ITAM',
      'Asset Visibility',
      'Cost Optimization',
      'Compliance & Security',
      'IT Leaders & CIOs',
    ],
    type: 'brochures',
    name: 'Brochures',
    url: '/assets/docs/brochures/new/Asset.pdf',
    // icon: '/assets/img/document-thumbnails/assets-brochure-thumbnail.webp',
    thumbnail: [
      {
        small: '/assets/img/thumbnails/new/brochures/asset-small.png',
        large: '/assets/img/thumbnails/new/brochures/assets.png',
      },
    ],
    format: 'pdf',
    featured: false,
    downloads: 5,
    preSelected: true,
  },
  {
    id: 2,
    slug: 'infraon-infinity-enterprise',
    title: 'Infraon Infinity Enterprise',
    product: 'Infraon Infinity',
    subtitle: 'All-In-One Enterprise Modernization Suite',
    description:
      'Unified IT operations platform combining ITSM, ITAM, infrastructure monitoring, and automation for enterprise-scale management. Replace 5+ disconnected tools, reduce licensing costs 60%, achieve single-pane visibility, and streamline operations.',
    topics: [
      'ITSM',
      'IT Operations',
      'IT Automation',
      'Cost Optimization',
      'Intelligent Automation',
      'Enterprise IT',
      'IT Operations Teams',
    ],
    type: 'brochures',
    name: 'Brochures',
    url: '/assets/docs/brochures/new/Infinity.pdf',
    // icon: '/assets/img/document-thumbnails/infinity-brochure-thumbnail.webp',
    thumbnail: [
      {
        small: '/assets/img/thumbnails/new/brochures/infinity-small.png',
        large: '/assets/img/thumbnails/new/brochures/infinity.png',
      },
    ],
    format: 'pdf',
    featured: false,
    downloads: 27,
    preSelected: true,
  },
  {
    id: 3,
    slug: 'infraon-aiops',
    title: 'Infraon AIOps',
    product: 'Infraon AIOps',
    subtitle: 'AI-Powered Unified Platform for Proactive and Resilient ITOps',
    description:
      'Infraon AIOps applies machine learning-driven event correlation and anomaly detection to enterprise IT operations',
    topics: ['AIOps'],
    type: 'brochures',
    name: 'Brochures',
    url: '/assets/docs/brochures/new/AIOps.pdf',
    // icon: '/assets/img/document-thumbnails/infinity-msp-brochure-thumbnail-01.webp',
    thumbnail: [
      {
        small: '/assets/img/thumbnails/new/brochures/infinity-small.png',
        large: '/assets/img/thumbnails/new/brochures/infinity.png',
      },
    ],
    format: 'pdf',
    featured: false,
    downloads: 0,
    preSelected: true,
  },
  {
    id: 4,
    slug: 'infraon-itsm',
    title: 'Infraon ITSM',
    product: 'Infraon ITSM',
    subtitle: 'End-to-End IT Service Management Platform',
    description:
      'GenAI-powered IT service management with 72-hour deployment, intelligent automation, and predictive resolution. ITIL 4 certified platform delivering accelerated incident resolution, multi-channel support, and unified service desk for enterprises.',
    topics: [
      'ITSM',
      'IT Automation',
      'Compliance & Security',
      'Generative AI',
      'Service Desk Teams',
    ],
    type: 'brochures',
    name: 'Brochures',
    url: '/assets/docs/brochures/new/ITSM.pdf',
    // icon: '/assets/img/document-thumbnails/itsm-brochure-thumbnail.webp',
    thumbnail: [
      {
        small: '/assets/img/thumbnails/new/brochures/itsm-small.png',
        large: '/assets/img/thumbnails/new/brochures/itsm.png',
      },
    ],
    format: 'pdf',
    featured: false,
    downloads: 0,
    preSelected: false,
  },
  {
    id: 5,
    slug: 'infraon-ims',
    title: 'Infraon IMS',
    product: 'Infraon IMS',
    subtitle: 'Unified Network Management Platform',
    description:
      'Cloud-based network monitoring system providing comprehensive visibility across multi-vendor network devices. Monitor routers, switches, firewalls, and servers from a single dashboard. Streamline network health management with real-time alerting.',
    topics: [
      'IMS',
      'IT Operations',
      'Alert Management',
      'Cloud Monitoring',
      'IP Address Management',
      'IT Operations Teams',
    ],
    type: 'brochures',
    name: 'Brochures',
    url: '/assets/docs/brochures/new/IMS.pdf',
    // icon: '/assets/img/document-thumbnails/nms-brochure-thumbnail.webp',
    thumbnail: [
      {
        small: '/assets/img/thumbnails/new/brochures/ims-small.png',
        large: '/assets/img/thumbnails/new/brochures/ims.png',
      },
    ],
    format: 'pdf',
    featured: false,
    downloads: 112,
    preSelected: false,
  },
  {
    id: 6,
    slug: 'infraon-oss',
    title: 'Infraon OSS',
    product: 'Infraon OSS',
    subtitle: 'Operations Support System for Digital Transformation Success',
    description:
      'An all-in-one OSS solution for administering, operating, monitoring, and provisioning multi-vendor, multi-technology networks - covering transport, transmission, packet core, distributed, access, and communication networks, as well as ISPs providing FTTH services.',
    topics: ['Telecommunications', 'OSS'],
    type: 'brochures',
    name: 'Brochures',
    url: '/assets/docs/brochures/new/OSS.pdf',
    // icon: '/assets/img/document-thumbnails/itim-brochure-thumbnail.webp',
    thumbnail: [
      {
        small: '/assets/img/thumbnails/new/brochures/ims-small.png',
        large: '/assets/img/thumbnails/new/brochures/ims.png',
      },
    ],
    format: 'pdf',
    featured: false,
    downloads: 0,
    preSelected: false,
  },
  {
    id: 7,
    slug: 'infraon-nccm',
    title: 'Infraon NCCM',
    product: 'Infraon NCCM',
    subtitle: 'Network Configuration & Change Management',
    description:
      'NCCM software automates network configuration and change management compliance workflows, configuration backup, and vulnerability management for 15,000+ devices.Efficient ITSM platform using AGILE methods for service delivery transformation.',
    topics: ['IT Operations', 'NCCM', 'IT Automation'],
    type: 'brochures',
    name: 'Brochures',
    url: '/assets/docs/brochures/new/NCCM.pdf',
    // icon: '/assets/img/document-thumbnails/helpdesk-brochure-thumbnail.webp',
    thumbnail: [
      {
        small: '/assets/img/thumbnails/new/brochures/infinity-small.png',
        large: '/assets/img/thumbnails/new/brochures/infinity.png',
      },
    ],
    format: 'pdf',
    featured: false,
    downloads: 94,
    preSelected: false,
  },

  // case-studies
  {
    id: 9,
    slug: 'baldor-technologies',
    title: 'Baldor Technologies Pvt. Ltd',
    subtitle:
      'Baldor Technologies Achieves 25–50% Improvement in Productivity & Compliance with Infraon Assets',
    description:
      'Emerging HR analytics start-up eliminates spreadsheet dependency and manual audit processes with Infraon Assets. Achieves 25–50% increase in agent productivity and compliance improvement through automated asset data collection, barcode/QR code tracking, and streamlined asset allocation and approval workflows.',
    topics: ['ITAM', 'Asset Visibility', 'Compliance & Security', 'IT Operations Teams'],
    type: 'case-studies',
    product: 'Infraon Assets',
    industry: 'Technology (HR Analytics)',
    name: 'Case Studies',
    url: '/assets/docs/case-study/infraon-assets/infraon-assets-baldor-technologies-pvt-ltd.pdf',
    // icon: '/assets/img/thumbnails/new/case-study/baldor.png',
    thumbnail: [
      {
        small: '/assets/img/thumbnails/new/case-study/baldor.svg',
        large: '/assets/img/thumbnails/new/case-study/baldor.svg',
      },
    ],
    format: 'pdf',
    featured: false,
    downloads: 34,
    preSelected: true,
  },
  {
    id: 10,
    slug: 'emergya-wind-technologies',
    title: 'Emergya Wind Technologies (EWT)',
    subtitle: "EWT Improves Productivity and Compliance by 75% with Infraon's ITAM Solution",
    description:
      'Description (45 words): Global wind energy company with 600+ turbines across three continents replaces ineffective spreadsheets with Infraon ITAM. Achieves 50–75% increase in productivity and compliance through real-time asset tracking, software license management, asset categorization, and automated security controls.',
    topics: [
      'ITAM',
      'Asset Visibility',
      'Compliance & Security',
      'Cost Optimization',
      'IT Operations Teams',
    ],
    type: 'case-studies',
    product: 'Infraon Assets',
    industry: 'Renewable Energy (Wind Power)',
    name: 'Case Studies',
    url: '/assets/docs/case-study/infraon-assets/infraon-assets-emergya-wind-technologies.pdf',
    // icon: '/assets/img/partners/ewt-01.svg',
    thumbnail: [
      {
        small: '/assets/img/thumbnails/new/case-study/ewt.svg',
        large: '/assets/img/thumbnails/new/case-study/ewt.svg',
      },
    ],
    format: 'pdf',
    featured: false,
    downloads: 0,
    preSelected: false,
  },
  {
    id: 11,
    slug: 'gulshan-homz',
    title: 'Gulshan Homz Pvt. Ltd',
    subtitle: 'Gulshan Homz Achieves 50–75% Compliance Improvement with Infraon Assets',
    description:
      'Leading luxury real estate developer replaces manual asset processes with Infraon Assets, gaining real-time visibility across properties and offices. Achieves 25–50% productivity gain and 50–75% compliance improvement through lifecycle management, automated AMC reminders, software license tracking, and bulk asset onboarding.cta',
    topics: ['ITAM', 'Asset Visibility', 'Compliance & Security', 'IT Operations Teams'],
    type: 'case-studies',
    product: 'Infraon Assets',
    industry: 'Real Estate Development',
    name: 'Case Studies',
    url: '/assets/docs/case-study/infraon-assets/infraon-assets-gulshan-group.pdf',
    // icon: '/assets/img/thumbnails/new/case-study/gulshan.png',
    thumbnail: [
      {
        small: '/assets/img/thumbnails/new/case-study/gulshan.svg',
        large: '/assets/img/thumbnails/new/case-study/gulshan.svg',
      },
    ],
    format: 'pdf',
    featured: false,
    downloads: 0,
    preSelected: false,
  },
  {
    id: 12,
    slug: 'healthium-medtech',
    title: 'Healthium Medtech Ltd',
    subtitle:
      'Healthium Medtech Achieves 50–75% Improvement in Productivity, Compliance & IT Cost Savings with Infraon Assets',
    description:
      "Global medtech leader serving 90+ countries streamlines asset operations with Infraon's SaaS-based module. Achieves 50–75% improvement across agent productivity, organization compliance, and annual IT cost savings through automated inventory agent, bulk asset onboarding, and advanced software license management.cta",
    topics: [
      'IMS',
      'Asset Visibility',
      'Compliance & Security',
      'Cost Optimization',
      'IT Operations Teams',
    ],
    type: 'case-studies',
    product: 'Infraon Assets',
    industry: 'Medical Technology',
    name: 'Case Studies',
    url: '/assets/docs/case-study/infraon-assets/infraon-assets-healthium-medtech-pvt-ltd.pdf',
    // icon: '/assets/img/partners/healthium-01.svg',
    thumbnail: [
      {
        small: '/assets/img/thumbnails/new/case-study/healthium.svg',
        large: '/assets/img/thumbnails/new/case-study/healthium.svg',
      },
    ],
    format: 'pdf',
    featured: true,
    downloads: 0,
    preSelected: true,
  },
  {
    id: 13,
    slug: 'idfy',
    title: 'IDfy',
    subtitle: "IDfy Improves Compliance and Productivity by 50% with Infraon's ITAM Solution",
    description:
      "India's leading identity verification platform, processing 25 million monthly verifications, replaces spreadsheet-based asset tracking with Infraon ITAM. Achieves 25–50% productivity and compliance improvement through inventory agent installation, barcode/QR scanning, automated approval workflows, and centralized license management.",
    topics: ['ITAM', 'Asset Visibility', 'Compliance & Security', 'IT Operations Teams'],
    type: 'case-studies',
    product: 'Infraon Assets',
    industry: 'Information Technology (Fintech/Identity Verification)',
    name: 'Case Studies',
    url: '/assets/docs/case-study/infraon-assets/idfy.pdf',
    // icon: '/assets/img/thumbnails/new/case-study/idfy.svg',
    thumbnail: [
      {
        small: '/assets/img/thumbnails/new/case-study/idfy.svg',
        large: '/assets/img/thumbnails/new/case-study/idfy.svg',
      },
    ],
    format: 'pdf',
    featured: false,
    downloads: 9,
    preSelected: false,
  },
  {
    id: 14,
    slug: 'terrabit-consulting',
    title: 'Terrabit Consulting Pvt. Ltd',
    subtitle:
      "Terrabit Consulting Achieves 75% Compliance Improvement with Infraon's ITAM Solution",
    description:
      'IT consulting firm founded in 2009 gains full control over asset lifecycle after replacing spreadsheets with Infraon ITAM. Achieves 50% productivity increase and 75% compliance improvement through streamlined lifecycle management, barcode-based audits, automated inventory scanning, and centralized license visibility.cta',
    topics: ['ITAM', 'Asset Visibility', 'Compliance & Security', 'IT Operations Teams'],
    type: 'case-studies',
    product: 'Infraon Assets',
    industry: 'IT Consulting',
    name: 'Case Studies',
    url: '/assets/docs/case-study/infraon-assets/terrabit-consulting.pdf',
    // icon: '/assets/img/partners/terrabit-01.svg',
    thumbnail: [
      {
        small: '/assets/img/thumbnails/new/case-study/terrabit.svg',
        large: '/assets/img/thumbnails/new/case-study/terrabit.svg',
      },
    ],
    format: 'pdf',
    featured: false,
    downloads: 15,
    preSelected: false,
  },
  {
    id: 15,
    slug: 'infra-wala',
    title: 'Infra Wala',
    subtitle:
      "Infra Wala Transforms Customer Support Operations with Infraon's Unified Helpdesk Module",
    description:
      'Leading repair and maintenance management company replaces email and spreadsheet-based support with Infraon Helpdesk. Improves customer satisfaction, agent productivity, and compliance through omni-channel ticket creation, self-service portal, automated ticket allocation, mobile app access, and real-time analytics dashboards.cta',
    topics: ['ITSM', 'IT Automation', 'Service Desk Teams'],
    type: 'case-studies',
    product: 'Infraon Helpdesk',
    industry: 'Integrated Repair & Maintenance Management',
    name: 'Case Studies',
    url: '/assets/docs/case-study/infraon-helpdesk/infraon-helpdesk-infra-wala.pdf',
    // icon: '/assets/img/partners/infrawala.webp',
    thumbnail: [
      {
        small: '/assets/img/thumbnails/new/case-study/infrawala.svg',
        large: '/assets/img/thumbnails/new/case-study/infrawala.svg',
      },
    ],
    format: 'pdf',
    featured: false,
    downloads: 0,
    preSelected: false,
  },
  {
    id: 16,
    slug: 'act-fibernet',
    title: 'ACT Fibernet',
    subtitle:
      'ACT Fibernet Achieves Centralized Network Visibility and Reduced Device Outages with Infraon',
    description:
      'Leading Indian ISP serving nearly 2 million homes gains centralized monitoring of links, bandwidth, and SLAs across 5,000+ nodes. Reduces device outages and equips field engineers with pre-arrival issue intelligence through tree-based topology, helpdesk integration, and flexible license management.ion.',
    topics: ['IMS', 'NCCM', 'Alert Management', 'IP Address Management', 'IT Operations Teams'],
    type: 'case-studies',
    product: 'Infraon IMS',
    industry: 'Internet Services Provider',
    name: 'Case Studies',
    url: '/assets/docs/case-study/infraon-ims/ims-act.pdf',
    // icon: '/assets/img/thumbnails/new/case-study/act.svg',
    thumbnail: [
      {
        small: '/assets/img/thumbnails/new/case-study/act.svg',
        large: '/assets/img/thumbnails/new/case-study/act.svg',
      },
    ],
    format: 'pdf',
    featured: false,
    downloads: 67,
    preSelected: false,
  },
  {
    id: 17,
    slug: 'blackbox-corporation',
    title: 'BlackBox Corporation',
    subtitle:
      'BlackBox Corporation Achieves Centralized Monitoring of 1,200+ Network Devices with InfraonIMS',
    description:
      'Global communications infrastructure provider consolidates multi-tool monitoring into a single InfraonIMS deployment, actively monitoring 1,200+ network devices and servers. Gains role-based dashboards, granular tunnel monitoring across Cisco and Juniper devices, multi-level threshold alerting, and proactive fault management from a centralized US data center.',
    topics: [
      'IMS',
      'Alert Management',
      'IP Address Management',
      'Observability',
      'IT Operations Teams',
    ],
    type: 'case-studies',
    product: 'Infraon IMS',
    industry: 'IT Infrastructure & Communications',
    name: 'Case Studies',
    url: '/assets/docs/case-study/infraon-ims/ims-blackbox.pdf',
    // icon: '/assets/img/partners/black-box-grey-01.svg',
    thumbnail: [
      {
        small: '/assets/img/thumbnails/new/case-study/blackbox.svg',
        large: '/assets/img/thumbnails/new/case-study/blackbox.svg',
      },
    ],
    format: 'pdf',
    featured: false,
    downloads: 0,
    preSelected: false,
  },
  {
    id: 18,
    slug: 'geojit-bnp-paribas',
    title: 'Geojit BNP Paribas',
    subtitle:
      'Geojit BNP Paribas Achieves Near-Zero Downtime Across 500+ Branches with Infraon IMS',
    description:
      "Leading retail financial services company managing 3,000+ systems across 500+ branches achieves 99.99% network uptime during peak trading hours. Gains proactive fault detection, root-cause analysis, centralized geographic branch visibility, improved MTTR, and vendor SLA management through Infraon's network monitoring solution.ion.",
    topics: [
      'IMS',
      'Alert Management',
      'IP Address Management',
      'Observability',
      'IT Operations Teams',
    ],
    type: 'case-studies',
    product: 'Infraon IMS',
    industry: 'Financial Services (Capital Markets)',
    name: 'Case Studies',
    url: '/assets/docs/case-study/infraon-ims/ims-geojit.pdf',
    // icon: '/assets/img/partners/healthium-01.svg',
    thumbnail: [
      {
        small: '/assets/img/thumbnails/new/case-study/geojit.svg',
        large: '/assets/img/thumbnails/new/case-study/geojit.svg',
      },
    ],
    format: 'pdf',
    featured: false,
    downloads: 88,
    preSelected: false,
  },
  {
    id: 19,
    slug: 'global-isp-provider',
    title: 'Global ISP Provider',
    subtitle:
      'Global ISP Provider Streamlines Remote Customer IT Infrastructure Monitoring with Infraon IMS',
    description:
      'Global IT solutions provider operating across six continents consolidates fragmented monitoring tools into a single Infraon IMS deployment. Achieves centralized health and performance monitoring of 1,000+ network devices, granular Cisco and Juniper tunnel visibility, real-time alerting, and multi-tenant architecture for customer infrastructure management.cta',
    topics: ['IMS', 'IP Address Management', 'Observability', 'IT Operations Teams'],
    type: 'case-studies',
    product: 'Infraon IMS',
    industry: 'IT Infrastructure / Internet Services',
    name: 'Case Studies',
    url: '/assets/docs/case-study/infraon-ims/ims-isp.pdf',
    // icon: '/assets/img/partners/leader-01.svg',
    thumbnail: [
      {
        small: '/assets/img/thumbnails/new/case-study/isp.svg',
        large: '/assets/img/thumbnails/new/case-study/isp.svg',
      },
    ],
    format: 'pdf',
    featured: false,
    downloads: 0,
    preSelected: false,
  },
  {
    id: 20,
    slug: 'reliance-jio',
    title: 'Reliance Jio (RJIL)',
    subtitle:
      'Reliance Jio Ensures Uninterrupted 4G Connectivity Across 100,000+ Sites with Infraon IMS',
    description:
      "India's first pan-India unified license telecom operator deploys Infraon to monitor 250+ statistics per device across 100,000+ tower sites. Achieves minimal business downtime, predictive maintenance, real-time tower utility reporting, optimized diesel generator run-hours, and seamless SNMP trap integration with existing NOC infrastructure.cta",
    topics: ['IMS', 'Alert Management', 'Observability', 'IT Operations Teams'],
    type: 'case-studies',
    product: 'Infraon IMS',
    industry: 'Telecommunications',
    name: 'Case Studies',
    url: '/assets/docs/case-study/infraon-ims/ims-rjio.pdf',
    // icon: '/assets/img/thumbnails/new/case-study/jio.png',
    thumbnail: [
      {
        small: '/assets/img/thumbnails/new/case-study/jio.svg',
        large: '/assets/img/thumbnails/new/case-study/jio.svg',
      },
    ],
    format: 'pdf',
    featured: false,
    downloads: 0,
    preSelected: true,
  },
  {
    id: 21,
    slug: 'rajkot-airport',
    title: 'Rajkot Airport (AAI)',
    subtitle:
      'Rajkot Airport Achieves Unified, Real-Time IT Infrastructure Visibility with Infraon Infinity',
    description:
      "Airport Authority of India's Rajkot hub deploys Infraon Infinity to manage a heterogeneous fleet of network devices, servers, and legacy systems from a single console. Gains automated configuration backups, intelligent fault alerting, role-based dashboards, predictive analytics, and faster fault recovery across all infrastructure components.",
    topics: ['IT Operations', 'Alert Management', 'Enterprise IT'],
    type: 'case-studies',
    product: 'Infraon Infinity',
    industry: 'Government / Aviation',
    name: 'Case Studies',
    url: '/assets/docs/case-study/infraon-suite/infinity-aai-rajkot-airport.pdf',
    // icon: '/assets/img/partners/smet-01.svg',
    thumbnail: [
      {
        small: '/assets/img/thumbnails/new/case-study/aai.svg',
        large: '/assets/img/thumbnails/new/case-study/aai.svg',
      },
    ],
    format: 'pdf',
    featured: false,
    downloads: 0,
    preSelected: false,
  },
  {
    id: 22,
    slug: 'adsws',
    title: 'ADSWS (Abu Dhabi Sustainable Water Solutions Company)',
    subtitle:
      'ADSWS Boosts ITOps Capabilities and Achieves ISO 20K Compliance with Infraon Infinity',
    description:
      "Abu Dhabi's leading sustainable water solutions company deploys Infraon Infinity on premises to replace outsourced IT operations with in-house control. Achieves ISO/IEC 20000 certification, reduces vendor costs, improves team collaboration, and gains flexible SLA management through a fully integrated NMS, ITSM, and NCCM platform.cta",
    topics: [
      'ITSM',
      'IT Operations',
      'NCCM',
      'IT Automation',
      'Compliance & Security',
      'Enterprise IT',
    ],
    type: 'case-studies',
    product: 'Infraon Infinity',
    industry: 'Utilities / Water Management',
    name: 'Case Studies',
    url: '/assets/docs/case-study/infinity-adswsc.pdf',
    // icon: '/assets/img/partners/infrawala.webp',
    thumbnail: [
      {
        small: '/assets/img/thumbnails/new/case-study/ADSWS.svg',
        large: '/assets/img/thumbnails/new/case-study/ADSWS.svg',
      },
    ],
    format: 'pdf',
    featured: false,
    downloads: 0,
    preSelected: false,
  },
  {
    id: 23,
    slug: 'ask-fras-le-friction',
    title: 'ASK FRAS-LE FRICTION Pvt. Ltd.',
    subtitle:
      'ASK FRAS-LE Achieves 75% Improvement in Productivity, Compliance & IT Cost Savings with Infraon Infinity',
    description:
      "Joint venture automotive manufacturer replaces fragmented spreadsheets and manual support processes with Infraon Infinity's unified ITOps suite. Achieves 75% improvement in productivity, compliance, and IT cost reduction through real-time asset lifecycle tracking, no-code ticketing workflows, centralized knowledge base, and comprehensive software license management.cta",
    topics: [
      'ITSM',
      'ITAM',
      'IT Operations',
      'IT Automation',
      'Cost Optimization',
      'Compliance & Security',
      'Enterprise IT',
    ],
    type: 'case-studies',
    product: 'Infraon Infinity',
    industry: 'Manufacturing (Automotive Components)',
    name: 'Case Studies',
    url: '/assets/docs/case-study/ask-fres-le-friction-pvt-ltd.pdf',
    // icon: '/assets/img/partners/cesc-01.svg',
    thumbnail: [
      {
        small: '/assets/img/thumbnails/new/case-study/ask.svg',
        large: '/assets/img/thumbnails/new/case-study/ask.svg',
      },
    ],
    format: 'pdf',
    featured: false,
    downloads: 0,
    preSelected: true,
  },
  {
    id: 24,
    slug: 'eternis-fine-chemicals',
    title: 'Eternis Fine Chemicals Ltd.',
    subtitle: 'Eternis Fine Chemicals Achieves 50–75% Agent Productivity Gain with Infraon ITSM',
    description:
      "India's largest aroma chemicals exporter and Mariwala Group company replaces email-based service management with Infraon ITSM. Achieves 25–50% improvement in customer satisfaction and compliance, and 50–75% boost in agent productivity through omni-channel ticketing, automated multi-department approvals, SLA management, and integrated asset lifecycle tracking.cta",
    topics: ['ITSM', 'Compliance & Security', 'IT Automation', 'Service Desk Teams'],
    type: 'case-studies',
    product: 'Infraon ITSM',
    industry: 'Specialty Chemicals / Aroma Chemicals',
    name: 'Case Studies',
    url: '/assets/docs/case-study/infraon-itsm/infraon-itsm-eternis-fine-chemicals-ltd.pdf',
    // icon: '/assets/img/partners/sws-01.svg',
    thumbnail: [
      {
        small: '/assets/img/thumbnails/new/case-study/eternis.svg',
        large: '/assets/img/thumbnails/new/case-study/eternis.svg',
      },
    ],
    format: 'pdf',
    featured: false,
    downloads: 67,
    preSelected: false,
  },
  {
    id: 25,
    slug: 'healthium-medtech-itsm',
    title: 'Healthium Medtech Ltd. (ITSM)',
    subtitle:
      'Healthium Medtech Achieves Over 75% Improvement Across Customer Satisfaction, Productivity & Compliance with Infraon ITSM',
    description:
      "World's largest non-captive surgical needles manufacturer unifies fragmented ITSM tools into a single Infraon platform. Achieves over 75% improvement in customer satisfaction, agent productivity, IT cost reduction, and compliance adherence through self-service portal, automated ticket allocation, multi-profile SLA management, and real-time workload analytics.",
    topics: ['ITSM', 'Compliance & Security', 'IT Automation', 'Service Desk Teams'],
    type: 'case-studies',
    product: 'Infraon ITSM',
    industry: 'Medical Technology',
    name: 'Case Studies',
    url: '/assets/docs/case-study/infraon-itsm/infraon-itsm-healthium-medtech-pvt-ltd.pdf',
    // icon: '/assets/img/case-study/bsnl.svg',
    thumbnail: [
      {
        small: '/assets/img/thumbnails/new/case-study/healthium.svg',
        large: '/assets/img/thumbnails/new/case-study/healthium.svg',
      },
    ],
    format: 'pdf',
    featured: false,
    downloads: 34,
    preSelected: false,
  },
  {
    id: 26,
    slug: 'leader-it',
    title: 'Leader IT Pvt. Ltd.',
    subtitle:
      'Leader IT Achieves Over 75% Compliance Improvement and 50–75% Productivity Boost with Infraon ITSM',
    description:
      'Trivandrum-based IT firm serving Middle East clients transitions from a limited in-house application to Infraon ITSM. Achieves 50–75% improvement in customer satisfaction and agent productivity, over 75% compliance adherence, and 25–50% IT cost reduction through omni-channel ticketing, automated workflows, and asset lifecycle management.',
    topics: ['ITSM', 'Compliance & Security', 'IT Automation', 'Service Desk Teams'],
    type: 'case-studies',
    product: 'Infraon ITSM',
    industry: 'Information Technology / Software Development',
    name: 'Case Studies',
    url: '/assets/docs/case-study/infraon-itsm/infraon-itsm-leader-it-pvt-ltd.pdf',
    // icon: '/assets/img/case-study/tcs.svg',
    thumbnail: [
      {
        small: '/assets/img/thumbnails/new/case-study/leader-it.svg',
        large: '/assets/img/thumbnails/new/case-study/leader-it.svg',
      },
    ],
    format: 'pdf',
    featured: false,
    downloads: 34,
    preSelected: false,
  },
  {
    id: 27,
    slug: 'mbrsg',
    title: 'MBRSG (Mohammed Bin Rashid School of Government)',
    subtitle:
      'MBRSG Achieves 50–75% Compliance Improvement and Up to 75% Agent Productivity Gain with Infraon ITSM',
    description:
      "The Arab world's first governance and public policy institution replaces multi-channel manual support with Infraon ITSM. Achieves up to 75% improvement in agent productivity and 50–75% compliance increase through self-service portal, analytics-rich dashboards, multi-profile SLA management, and comprehensive AMC and software license tracking.",
    topics: ['ITSM', 'Compliance & Security', 'Service Desk Teams', 'IT Leaders & CIOs'],
    type: 'case-studies',
    product: 'Infraon ITSM',
    industry: 'Government / Public Policy Education',
    name: 'Case Studies',
    url: '/assets/docs/case-study/infraon-itsm/infraon-itsm-mbrsg.pdf',
    // icon: '/assets/img/case-study/fed_bank.svg',
    thumbnail: [
      {
        small: '/assets/img/thumbnails/new/case-study/mbrsg.svg',
        large: '/assets/img/thumbnails/new/case-study/mbrsg.svg',
      },
    ],
    format: 'pdf',
    featured: false,
    downloads: 34,
    preSelected: false,
  },
  {
    id: 28,
    slug: 'smet',
    title: 'SMET (SM Electronics)',
    subtitle:
      'SMET Achieves Over 75% Improvement Across Customer Satisfaction, Productivity & Compliance with Infraon ITSM',
    description:
      'Premier Indian electronic components distribution company founded in 1990, modernizes ITSM with Infraon, replacing email and spreadsheet-based tracking. Achieves over 75% improvement across customer satisfaction, agent productivity, IT spend reduction, and organizational compliance through automated ticket management, load distribution, and integrated asset lifecycle management.',
    topics: ['ITSM', 'Compliance & Security', 'IT Automation', 'Service Desk Teams'],
    type: 'case-studies',
    product: 'Infraon ITSM',
    industry: 'Electronic Components Distribution',
    name: 'Case Studies',
    url: '/assets/docs/case-study/infraon-itsm/infraon-itsm-smet.pdf',
    // icon: '/assets/img/case-study/yum.svg',
    thumbnail: [
      {
        small: '/assets/img/thumbnails/new/case-study/smet.svg',
        large: '/assets/img/thumbnails/new/case-study/smet.svg',
      },
    ],
    format: 'pdf',
    featured: false,
    downloads: 34,
    preSelected: false,
  },
  {
    id: 29,
    slug: 'tata-electronics',
    title: 'Tata Electronics (Major Semiconductor Manufacturer)',
    subtitle:
      "India's Largest Semiconductor Manufacturer Streamlines Operations and Access Management for 18,000+ Users with Infraon ITSM",
    description:
      "One of India's largest semiconductor manufacturers deploys Infraon ITSM to manage complex facility access permissions for 18,000+ employees across multi-block plants. Reduces ticket creation time and effort through multi-template request management, conditional bulk approvals, daily task recording, and location-based automated ticket routing across distributed facilities.",
    topics: ['ITSM', 'IT Automation', 'Service Desk Teams', 'Enterprise IT'],
    type: 'case-studies',
    product: 'Infraon ITSM',
    industry: 'Manufacturing (Semiconductors / Precision Components)',
    name: 'Case Studies',
    url: '/assets/docs/case-study/infraon-itsm/itsm-tata-electronics.pdf',
    // icon: '/assets/img/case-study/veloci.svg',
    thumbnail: [
      {
        small: '/assets/img/thumbnails/new/case-study/tata-electronics.svg',
        large: '/assets/img/thumbnails/new/case-study/tata-electronics.svg',
      },
    ],
    format: 'pdf',
    featured: false,
    downloads: 34,
    preSelected: false,
  },
  {
    id: 30,
    slug: 'udaan',
    title: 'Udaan',
    subtitle:
      "India's Largest B2B E-Commerce Platform Empowers 10,000+ Users with 360-Degree ITSM Solution from Infraon",
    description:
      "India's largest B2B distribution platform with 1 million+ retailers and 10,000+ employees deploys Infraon ITSM to unify support across 900+ cities. Enables 130 agents with 24×7 support, manages 15,000+ assets and 500+ daily tickets through Slack, HRMS, Azure AD integrations, and full workflow automation.",
    topics: ['ITSM', 'IT Automation', 'Service Desk Teams', 'Enterprise IT'],
    type: 'case-studies',
    product: 'Infraon ITSM',
    industry: 'B2B E-Commerce / Distribution',
    name: 'Case Studies',
    url: '/assets/docs/case-study/infraon-itsm/infraon-itsm-udaan.pdf',
    // icon: '/assets/img/case-study/qlm.svg',
    thumbnail: [
      {
        small: '/assets/img/thumbnails/new/case-study/udaan.svg',
        large: '/assets/img/thumbnails/new/case-study/udaan.svg',
      },
    ],
    format: 'pdf',
    featured: false,
    downloads: 34,
    preSelected: false,
  },
  {
    id: 31,
    slug: 'ust',
    title: 'UST (formerly UST Global)',
    subtitle:
      'UST Elevates IT Operations for 30,000 Users with On-Premises Infraon ITSM Deployment',
    description:
      'Global digital transformation leader UST deploys Infraon ITSM on premises to manage infrastructure for Muthoot Finance across data centers, HQ, and branches. Achieves higher productivity, faster resolution times, and improved CSAT through ITIL-compliant service management, MCM and Icinga NMS integration, AD/SSO, and complete asset lifecycle management.',
    topics: [
      'ITSM',
      'IT Automation',
      'Compliance & Security',
      'Service Desk Teams',
      'Enterprise IT',
    ],
    type: 'case-studies',
    product: 'Infraon ITSM',
    industry: 'IT Services / Digital Transformation',
    name: 'Case Studies',
    url: '/assets/docs/case-study/infraon-itsm/itsm-ust.pdf',
    // icon: '/assets/img/case-study/nelco.svg',
    thumbnail: [
      {
        small: '/assets/img/thumbnails/new/case-study/ust.svg',
        large: '/assets/img/thumbnails/new/case-study/ust.svg',
      },
    ],
    format: 'pdf',
    featured: false,
    downloads: 34,
    preSelected: false,
  },
  {
    id: 32,
    slug: 'yum-brands',
    title: "Yum! Brands (World's Largest Restaurant Company)",
    subtitle: "World's Largest Restaurant Brand Modernizes IT Service Ecosystem with Infraon ITSM",
    description:
      'Fortune 500 restaurant company operating 39,000+ outlets across 130+ countries deploy Infraon ITSM to eliminate ticketing redundancies and modernize service delivery. Streamlines operations with email-to-incident conversion, WhatsApp-to-incident integration, multilevel service catalogues, customized SLA-based resolution, and structured customer feedback collection across global restaurant operations.',
    topics: ['ITSM', 'IT Automation', 'Service Desk Teams', 'Enterprise IT'],
    type: 'case-studies',
    product: 'Infraon ITSM',
    industry: 'Food & Beverage / QSR (Quick Service Restaurants)',
    name: 'Case Studies',
    url: '/assets/docs/case-study/infraon-itsm/itsm-yum.pdf',
    // icon: '/assets/img/case-study/mbrs.svg',
    thumbnail: [
      {
        small: '/assets/img/thumbnails/new/case-study/yum.svg',
        large: '/assets/img/thumbnails/new/case-study/yum.svg',
      },
    ],
    format: 'pdf',
    featured: false,
    downloads: 34,
    preSelected: false,
  },
  {
    id: 33,
    slug: 'canara-bank',
    title: 'Canara Bank (Top 5 Public Sector Bank)',
    subtitle:
      'Top 5 Indian Public Sector Banks Reduce ACL/NAC Configuration Time from Days to Minutes with Infraon NCCM',
    description:
      "One of India's largest public sector banks with 10,000 branches automates network configuration and compliance workflows for 15,000+ multi-vendor devices using Infraon NCCM. Achieves real-time vulnerability detection, RBI compliance adherence, unauthorized access prevention, and configuration error reduction through intelligent change tracking and approval-based deployment.",
    topics: ['NCCM', 'Compliance & Security', 'IT Operations Teams', 'Enterprise IT'],
    type: 'case-studies',
    product: 'Infraon NCCM',
    industry: 'Banking / Financial Services',
    name: 'Case Studies',
    url: '/assets/docs/case-study/case-study-canera-bank.pdf',
    // icon: '/assets/img/case-study/geogit.svg',
    thumbnail: [
      {
        small: '/assets/img/thumbnails/new/case-study/canera-bank.svg',
        large: '/assets/img/thumbnails/new/case-study/canera-bank.svg',
      },
    ],
    format: 'pdf',
    featured: false,
    downloads: 34,
    preSelected: false,
  },
  {
    id: 34,
    slug: 'cesc',
    title: 'CESC Limited',
    subtitle: 'CESC Achieves Real-Time Network Visibility and Minimized Downtime with Infraon NMS',
    description:
      "India's first fully integrated electrical utility company serving 3.4 million consumers deploys Infraon NMS for single-screen, real-time visibility across all network devices and servers via SNMP/WMI. Achieves instant fault alerting, scheduled configuration backups, customizable MIS reports, and centralized topology visualization for minimized network downtime.",
    topics: [
      'IMS',
      'Alert Management',
      'IP Address Management',
      'Observability',
      'IT Operations Teams',
    ],
    type: 'case-studies',
    product: 'Infraon IMS',
    industry: 'Power / Electrical Utility ',
    name: 'Case Studies',
    url: '/assets/docs/case-study/infraon-ims/infraon-ims-cesc.pdf',
    // icon: '/assets/img/case-study/cesc.svg',
    thumbnail: [
      {
        small: '/assets/img/thumbnails/new/case-study/cesc.svg',
        large: '/assets/img/thumbnails/new/case-study/cesc.svg',
      },
    ],
    format: 'pdf',
    featured: false,
    downloads: 34,
    preSelected: false,
  },
  {
    id: 36,
    slug: 'telecom-malaysia',
    title: 'Telecom Malaysia (TM)',
    subtitle:
      'Telecom Malaysia Accelerates 5G Rollout and Achieves Real-Time QoS Monitoring with Infraon OSS',
    description:
      "Malaysia's premier government-linked telecom provider deploys Infraon OSS to manage its multi-vendor 5G network across NG Core, Aggregator, IGW, and CSR elements using Agile Open Container Methodology. Gains Zero Touch Provisioning, NIST-based vulnerability detection, end-to-end service assurance, real-time quality of service (QoS) monitoring, and centralized configuration management.",
    topics: ['IT Operations', 'IT Automation', 'Compliance & Security', 'IT Operations Teams'],
    type: 'case-studies',
    product: 'Infraon OSS',
    industry: 'Telecommunications',
    name: 'Case Studies',
    url: '/assets/docs/case-study/infraon-oss/oss-tm.pdf',
    // icon: '/assets/img/case-study/canara_bank.svg',
    thumbnail: [
      {
        small: '/assets/img/thumbnails/new/case-study/tm.svg',
        large: '/assets/img/thumbnails/new/case-study/tm.svg',
      },
    ],
    format: 'pdf',
    featured: false,
    downloads: 34,
    preSelected: false,
  },
  {
    id: 37,
    slug: 'uae-tsp',
    title: 'UAE TSP (Telecom Service Provider)',
    subtitle:
      'Leading UAE Telecom Provider Scales FTTH Rollout to 4 Million Subscribers with Infraon OSS',
    description:
      "UAE's leading FTTH service provider deploys Infraon's turnkey OSS solution to unify Huawei, Eltex, and Delsa infrastructure through GIS-integrated inventory and BPA-driven orchestration. Achieves zero-touch ONT provisioning, real-time feasibility validation, cross-domain SLA adherence, proactive fault detection, and scalable architecture for 4 million subscriber deployments.",
    topics: ['IT Operations', 'IT Automation', 'IT Operations Teams'],
    type: 'case-studies',
    product: 'Infraon OSS',
    industry: 'Telecommunications / FTTH',
    name: 'Case Studies',
    url: '/assets/docs/case-study/infraon-oss/oss-uae-tsp-case-study.pdf',
    // icon: '/assets/img/case-study/canara_bank.svg',
    thumbnail: [
      {
        small: '/assets/img/thumbnails/new/case-study/tsp.svg',
        large: '/assets/img/thumbnails/new/case-study/tsp.svg',
      },
    ],
    format: 'pdf',
    featured: false,
    downloads: 34,
    preSelected: false,
  },
  {
    id: 38,
    slug: 'infraon-suite-bsnl',
    title: 'Infraon Suite - BSNL',
    subtitle:
      'BSNL Achieves 99% SLA Adherence and Eliminates Penalty Costs Across Madhya Pradesh with Infraon Suite',
    description:
      "India's largest fixed telephony and broadband provider deploys Infraon Suite (IMS + ITSM) to proactively monitor link health across thousands of locations serving Madhya Pradesh, SWAN, and the High Court. Achieves 99% SLA adherence, automatic fault-to-ticket creation, root-cause analysis, RIMS-based remote management, and elimination of SLA breach penalties.",
    topics: [
      'ITSM',
      'IMS',
      'IT Operations',
      'Alert Management',
      'IT Automation',
      'Enterprise IT',
      'IT Operations Teams',
    ],
    type: 'case-studies',
    product: 'Infraon Infinity',
    industry: 'Telecommunications',
    name: 'Case Studies',
    url: '/assets/docs/case-study/infraon-suite/suite-bsnl.pdf',
    // icon: '/assets/img/case-study/canara_bank.svg',
    thumbnail: [
      {
        small: '/assets/img/thumbnails/new/case-study/bsnl.svg',
        large: '/assets/img/thumbnails/new/case-study/bsnl.svg',
      },
    ],
    format: 'pdf',
    featured: false,
    downloads: 34,
    preSelected: false,
  },
  {
    id: 39,
    slug: 'cloudnine-hospitals',
    title: 'Cloudnine Hospitals',
    subtitle:
      'Cloudnine Hospitals Ensures Patient-First Care with Proactive IT Infrastructure Monitoring via Infraon Suite',
    description:
      "India's leading specialty mother and childcare hospital chain, deploying Infraon Suite (IMS + ITSM) across its national network, gains hawk-eye visibility over 400+ devices. Achieves proactive fault detection, minimizes MPLS downtime, centralizes incident management, monitors database for patient records, improves MTTR, and significantly reduces TCO.",
    topics: ['IMS', 'IT Operations', 'Alert Management', 'Enterprise IT'],
    type: 'case-studies',
    product: 'Infraon Infinity',
    industry: 'Healthcare (Mother & Child Care)',
    name: 'Case Studies',
    url: '/assets/docs/case-study/infraon-suite/suite-cloudnine.pdf',
    // icon: '/assets/img/case-study/canara_bank.svg',
    thumbnail: [
      {
        small: '/assets/img/thumbnails/new/case-study/cloudnine.svg',
        large: '/assets/img/thumbnails/new/case-study/cloudnine.svg',
      },
    ],
    format: 'pdf',
    featured: false,
    downloads: 34,
    preSelected: false,
  },
  {
    id: 40,
    slug: 'd-vois',
    title: 'D-VoIS',
    subtitle:
      'D-VoIS Achieves 99% SLA Adherence and Unifies NOC Operations for 200,000+ Links with Infraon Suite',
    description:
      "Category 'A' ISP with 2 lakh+ customers and 25,000 access points across India deploys Infraon Suite to unify link monitoring and ticketing into a single platform. Achieves 99% SLA adherence, proactive alarm-to-ticket automation, geo-map fault visibility, mobile app for field engineers, and seamless HADOOP and CRM integration.",
    topics: ['IMS', 'IT Operations', 'Alert Management', 'IT Automation', 'IT Operations Teams'],
    type: 'case-studies',
    product: 'Infraon Infinity',
    industry: 'Internet Services / Broadband',
    name: 'Case Studies',
    url: '/assets/docs/case-study/infraon-old/case-study-d-vois.pdf',
    // icon: '/assets/img/case-study/canara_bank.svg',
    thumbnail: [
      {
        small: '/assets/img/thumbnails/new/case-study/d-vois.svg',
        large: '/assets/img/thumbnails/new/case-study/d-vois.svg',
      },
    ],
    format: 'pdf',
    featured: false,
    downloads: 34,
    preSelected: false,
  },
  {
    id: 41,
    slug: 'federal-bank',
    title: 'Federal Bank',
    subtitle:
      "Federal Bank Gains Full PAN India Network Visibility and Control with Infraon's Integrated NCCM, IMS & ITSM Suite",
    description:
      "Leading neo-banking player with 1,370 branches deploys Infraon's integrated product suite to unify network configuration, infrastructure monitoring, and IT service management. Gains PAN India visibility, automated vulnerability detection, RBI-aligned policy compliance, Netflow-based bandwidth analysis, automatic alert-to-ticket creation, and reduced network downtime across all branch operations.",
    topics: [
      'ITSM',
      'IMS',
      'NCCM',
      'Compliance & Security',
      'IT Automation',
      'Enterprise IT',
      'IT Operations Teams',
    ],
    type: 'case-studies',
    product: 'Infraon Infinity',
    industry: 'Banking / Financial Services',
    name: 'Case Studies',
    url: '/assets/docs/case-study/case-study-federal-bank.pdf',
    // icon: '/assets/img/case-study/canara_bank.svg',
    thumbnail: [
      {
        small: '/assets/img/thumbnails/new/case-study/fedreral-bank.svg',
        large: '/assets/img/thumbnails/new/case-study/federal-bank.svg',
      },
    ],
    format: 'pdf',
    featured: false,
    downloads: 34,
    preSelected: false,
  },
  {
    id: 42,
    slug: 'indian-police-departments',
    title: 'Indian Police Departments (Indian Law Enforcement Agency)',
    subtitle: 'How Infraon Helped Modernize ITOps Management Across Police Departments in India',
    description:
      "State police departments and law enforcement agencies across India gain centralized NOC capabilities with Infraon's ITOps suite. Achieves enhanced monitoring, faster incident resolution, and improved IT team productivity through real-time CCTV and device surveillance, automated ticket creation, single sign-in console, and dynamic dashboards.",
    topics: ['IMS', 'IT Operations', 'Alert Management', 'IT Operations Teams'],
    type: 'case-studies',
    product: 'Infraon IMS',
    industry: 'Government / Law Enforcement',
    name: 'Case Studies',
    url: '/assets/docs/case-study/infraon-ims/suite-indian-police-departments.pdf',
    // icon: '/assets/img/case-study/canara_bank.svg',
    thumbnail: [
      {
        small: '/assets/img/thumbnails/new/case-study/indian-police.svg',
        large: '/assets/img/thumbnails/new/case-study/indian-police.svg',
      },
    ],
    format: 'pdf',
    featured: false,
    downloads: 34,
    preSelected: false,
  },
  {
    id: 43,
    slug: 'tcs-passport-seva-project',
    title: 'TCS – Passport Seva Project (PSK)',
    subtitle: 'How Infraon Helped TCS Boost the Effectiveness of the Passport Seva Project',
    description:
      "TCS deploys Infraon's integrated suite to manage the Passport Seva Project across India, monitoring 3,000 network devices, automating 1,000 devices, managing 1,70,000 assets, and handling 100 remote desktop licenses. Achieves single-vendor coverage across IMS, ITSM, NCCM, Patch Management, and Remote Access modules.",
    topics: ['ITSM', 'ITAM', 'IT Operations', 'IT Automation', 'Enterprise IT'],
    type: 'case-studies',
    product: 'Infraon Infinity',
    industry: 'IT Services / Government (Passport Services)',
    name: 'Case Studies',
    url: '/assets/docs/case-study/infraon-suite/suite-tcs-psk.pdf',
    // icon: '/assets/img/case-study/canara_bank.svg',
    thumbnail: [
      {
        small: '/assets/img/thumbnails/new/case-study/tcs.svg',
        large: '/assets/img/thumbnails/new/case-study/tcs.svg',
      },
    ],
    format: 'pdf',
    featured: false,
    downloads: 34,
    preSelected: false,
  },
  {
    id: 44,
    slug: 'tatanet-services',
    title: 'Tatanet Services Limited (Nelco/Tatanet)',
    subtitle:
      'Tatanet Services Limited Scales Operations to 80,000+ Nodes with Improved SLA Compliance Using Infraon ITSM',
    description:
      'The top three VSAT service providers managing 15,000–20,000 complaints system-wide replace manual processes with Infraon ITSM. Achieves improved ticket resolution times, higher SLA compliance, and enhanced customer satisfaction through customizable ticketing, automated SLA management, performance dashboards, and scalable infrastructure supporting 80,000+ nodes.',
    topics: ['ITSM', 'IT Automation', 'Compliance & Security', 'Service Desk Teams'],
    type: 'case-studies',
    product: 'Infraon ITSM',
    industry: 'Telecommunications (VSAT Services)',
    name: 'Case Studies',
    url: '/assets/docs/case-study/infraon-itsm/itsm-nelco-tatanet.pdf',
    // icon: '/assets/img/case-study/canara_bank.svg',
    thumbnail: [
      {
        small: '/assets/img/thumbnails/new/case-study/tatanet.svg',
        large: '/assets/img/thumbnails/new/case-study/tatanet.svg',
      },
    ],
    format: 'pdf',
    featured: false,
    downloads: 34,
    preSelected: false,
  },
  {
    id: 45,
    slug: 'qlm-life-and-medical-insurance',
    title: 'QLM Life and Medical Insurance',
    subtitle:
      'QLM Life and Medical Insurance Achieves 50–75% Improvement in Customer Satisfaction with Infraon ITSM',
    description:
      'Leading MENA insurer streamlines customer support and asset operations with Infraon ITSM. Achieves 50–75% improvement in customer satisfaction, 25–50% cost reduction on IT spends, and 25–50% compliance improvement through real-time asset management, a code-free self-service portal, and Gen AI-powered automated ticket prioritization.',
    topics: [
      'ITSM',
      'Compliance & Security',
      'IT Automation',
      'Generative AI',
      'Service Desk Teams',
    ],
    type: 'case-studies',
    product: 'Infraon ITSM',
    industry: 'Insurance (MENA Region)',
    name: 'Case Studies',
    url: '/assets/docs/case-study/itsm-qlm.pdf',
    // icon: '/assets/img/case-study/canara_bank.svg',
    thumbnail: [
      {
        small: '/assets/img/thumbnails/new/case-study/qlm.svg',
        large: '/assets/img/thumbnails/new/case-study/qlm.svg',
      },
    ],
    format: 'pdf',
    featured: false,
    downloads: 34,
    preSelected: false,
  },
  {
    id: 46,
    slug: 'sea-infonet',
    title: 'SEA Infonet Pvt. Ltd.',
    subtitle:
      'SEA Infonet Achieves 75% Compliance Improvement and 50–75% Customer Satisfaction Gains with Infraon ITSM',
    description:
      "India's leading IT security value-added distributor with 1,000+ partners across 11 cities replaces manual ticketing with Infraon ITSM. Achieves 50–75% improvement in customer satisfaction, 75% compliance improvement, and 25–50% IT cost reduction through Gen AI ticket prioritization, SLA management, no-code workflows, and real-time workload monitoring.",
    topics: [
      'ITSM',
      'Compliance & Security',
      'IT Automation',
      'Generative AI',
      'Service Desk Teams',
    ],
    type: 'case-studies',
    product: 'Infraon ITSM',
    industry: 'Information Technology (IT Security Distribution)',
    name: 'Case Studies',
    url: '/assets/docs/case-study/sea-infonet.pdf',
    // icon: '/assets/img/case-study/canara_bank.svg',
    thumbnail: [
      {
        small: '/assets/img/thumbnails/new/case-study/sea-infonet.svg',
        large: '/assets/img/thumbnails/new/case-study/sea-infonet.svg',
      },
    ],
    format: 'pdf',
    featured: false,
    downloads: 34,
    preSelected: false,
  },
  {
    id: 47,
    slug: 'velocis',
    title: 'Velocis',
    subtitle:
      'Velocis Achieves 40% Productivity Increase and 80% Reduction in Training Time with Infraon ITAM',
    description:
      'Leading Indian system integrator with 1,200+ professionals and 130+ locations streamline pan-India asset and support operations with Infraon ITAM. Achieves 40% productivity increase and 80% reduction in training time through bulk asset uploads, barcode/QR tracking, automated SLA management, and centralized multi-customer visibility dashboards.',
    topics: ['ITAM', 'Asset Visibility', 'Cost Optimization', 'IT Operations Teams'],
    type: 'case-studies',
    product: 'Infraon Assets',
    industry: 'IT Services / System Integration',
    name: 'Case Studies',
    url: '/assets/docs/case-study/infraon-assets/msp-asset-velocis.pdf',
    // icon: '/assets/img/case-study/canara_bank.svg',
    thumbnail: [
      {
        small: '/assets/img/thumbnails/new/case-study/velocis.svg',
        large: '/assets/img/thumbnails/new/case-study/velocis.svg',
      },
    ],
    format: 'pdf',
    featured: false,
    downloads: 34,
    preSelected: false,
  },
  {
    id: 48,
    slug: 'jcnl',
    title: 'JCNL (Jharkhand Communication Network Limited)',
    subtitle:
      'JCNL Achieves Centralized GPON Network Management Across State and Central NOCs with Infraon OSS',
    description:
      'State-owned telecom company enabling Digital India connectivity deploys Infraon OSS to monitor 110 OLTs and 2,000 ONTs across a complex GPON infrastructure. Gains centralized multi-service management for internet, voice, video, Wi-Fi, and IPTV through event correlation, root cause analysis, integrated ticketing, and State-Central NOC integration.',
    topics: ['IT Operations', 'IT Automation', 'IT Operations Teams'],
    type: 'case-studies',
    product: 'Infraon OSS',
    industry: 'Telecommunications (Government)',
    name: 'Case Studies',
    url: '/assets/docs/case-study/infraon-oss/oss-jcnl.pdf',
    // icon: '/assets/img/case-study/canara_bank.svg',
    thumbnail: [
      {
        small: '/assets/img/thumbnails/new/case-study/jharkhand.svg',
        large: '/assets/img/thumbnails/new/case-study/jharkhand.svg',
      },
    ],
    format: 'pdf',
    featured: false,
    downloads: 34,
    preSelected: false,
  },
  {
    id: 49,
    slug: 'scl',
    title: 'SCL (Summit Communications Limited)',
    subtitle:
      'SCL Achieves Unified Network Management Across 46,000 KM Fiber Network with Infraon OSS',
    description:
      'Prominent telecom infrastructure provider operating a 46,000 KM fiber optic network consolidates fragmented operations with Infraon OSS. Gains unified monitoring of 5,000+ IP/MPLS devices and 100+ transport network elements, cross-domain correlation, closed-loop automation, and dedicated customer portal access with geo-map topology visualization.',
    topics: ['IT Operations', 'IT Automation', 'IT Operations Teams'],
    type: 'case-studies',
    product: 'Infraon OSS',
    industry: 'Telecommunications (Enterprise)',
    name: 'Case Studies',
    url: '/assets/docs/case-study/infraon-oss/oss-scl.pdf',
    // icon: '/assets/img/case-study/canara_bank.svg',
    thumbnail: [
      {
        small: '/assets/img/thumbnails/new/case-study/scl.svg',
        large: '/assets/img/thumbnails/new/case-study/scl.svg',
      },
    ],
    format: 'pdf',
    featured: false,
    downloads: 34,
    preSelected: false,
  },
  {
    id: 50,
    slug: 'ttsl',
    title: 'TTSL (Tata Teleservices Limited)',
    subtitle:
      'TTSL Optimizes Its 125,000 KM Fiber Network with Unified Multi-Technology Management Using Infraon OSS',
    description:
      'Tata Teleservices Limited, managing a 125,000 KM fiber network across 22 telecom circles, deploys Infraon OSS to unify 40,000+ network elements across 100+ EMS systems. Achieves centralized inventory tracking, circuit discovery, and stitching across SDH, DWDM, ASON, OTN, PTN, and IP/MPLS, with transmission auditing and capacity planning.',
    topics: ['IT Operations', 'IT Automation', 'IT Operations Teams'],
    type: 'case-studies',
    product: 'Infraon OSS',
    industry: 'Telecommunications (PSU)',
    name: 'Case Studies',
    url: '/assets/docs/case-study/infraon-oss/oss-ttsl.pdf',
    // icon: '/assets/img/case-study/canara_bank.svg',
    thumbnail: [
      {
        small: '/assets/img/thumbnails/new/case-study/tatatele.svg',
        large: '/assets/img/thumbnails/new/case-study/tatatele.svg',
      },
    ],
    format: 'pdf',
    featured: false,
    downloads: 34,
    preSelected: false,
  },
  {
    id: 51,
    slug: 'airtel',
    title: 'Airtel',
    subtitle:
      'Airtel Cuts IT Costs by 40%, Boosts Productivity by 30%, and Reduces Ticket Volume by 50% with Infraon OSS',
    description:
      "India's leading ICT services provider automates network operations across ~100,000 links with Infraon OSS. Achieves 25–30% productivity increase, 30–40% IT cost reduction, and 50% reduction in both tickets and alert noise through unified multi-vendor monitoring, automated link provisioning, event pattern analysis, and real-time portal access for 400+ corporate customers.",
    topics: [
      'IT Operations',
      'Traffic Flow Analysis',
      'Cost Optimization',
      'IT Automation',
      'IT Operations Teams',
    ],
    type: 'case-studies',
    product: 'Infraon OSS',
    industry: 'Telecommunications (IT Services)',
    name: 'Case Studies',
    url: '/assets/docs/case-study/infraon-oss/oss-airtel.pdf',
    // icon: '/assets/img/case-study/canara_bank.svg',
    thumbnail: [
      {
        small: '/assets/img/thumbnails/new/case-study/airtel.svg',
        large: '/assets/img/thumbnails/new/case-study/airtel.svg',
      },
    ],
    format: 'pdf',
    featured: false,
    downloads: 34,
    preSelected: false,
  },
  {
    id: 52,
    slug: 'pgcil',
    title: 'PGCIL (Power Grid Corporation of India Limited)',
    subtitle:
      'PGCIL Achieves 99% Service Availability and Centralized Legacy Network Control with Infraon OSS',
    description:
      "India's leading electricity transmission organization, managing 41,000 KM of fiber optic network across SDH, PDH, DWDM, and IP MPLS technologies, consolidates 10+ EMS systems with Infraon OSS. Achieves 99% service availability, reduced OEM/MSP dependency, automated fault management, GIS-integrated inventory tracking, and end-to-end L2/L3 service provisioning.",
    topics: ['IT Operations', 'IT Automation', 'Compliance & Security', 'Enterprise IT'],
    type: 'case-studies',
    product: 'Infraon OSS',
    industry: 'Power / Energy Transmission (Public Sector)',
    name: 'Case Studies',
    url: '/assets/docs/case-study/infraon-oss/oss-pgcil.pdf',
    // icon: '/assets/img/case-study/canara_bank.svg',
    thumbnail: [
      {
        small: '/assets/img/thumbnails/new/case-study/powergrid.svg',
        large: '/assets/img/thumbnails/new/case-study/powergrid.svg',
      },
    ],
    format: 'pdf',
    featured: false,
    downloads: 34,
    preSelected: false,
  },
  {
    id: 53,
    slug: 'tanfinet',
    title: 'TANFINET (Tamil Nadu Fiber Network)',
    subtitle:
      'TANFINET Accelerates Service Provisioning from Days to Minutes Across 55,000 KM Network with Infraon OSS',
    description:
      "Tamil Nadu's state-led digital connectivity initiative, connecting 12,500+ gram panchayats, gains centralized end-to-end network visibility with Infraon OSS. Reduces MTTR, automates fault ticketing for field engineers, accelerates service provisioning from days to minutes, and enables cross-domain correlation across DWDM and IP/MPLS cores via GIS-integrated inventory management.",
    topics: ['IT Operations', 'IT Automation', 'IT Operations Teams'],
    type: 'case-studies',
    product: 'Infraon OSS',
    industry: 'ISP (Government)',
    name: 'Case Studies',
    url: '/assets/docs/case-study/infraon-oss/oss-tanfinet.pdf',
    // icon: '/assets/img/case-study/canara_bank.svg',
    thumbnail: [
      {
        small: '/assets/img/thumbnails/new/case-study/tanfinet.svg',
        large: '/assets/img/thumbnails/new/case-study/tanfinet.svg',
      },
    ],
    format: 'pdf',
    featured: false,
    downloads: 34,
    preSelected: false,
  },
  {
    id: 54,
    slug: 'airtel-cinema',
    title: 'Airtel CINEMA',
    subtitle:
      'Airtel Ensures Uninterrupted Cinema Experience Across 87 Locations with Infraon Suite',
    description:
      "India's largest mobile network operator deploys Infraon Suite (IMS + ITSM) to monitor 200+ VSAT connections and 1,000+ devices across 87 digital media sites. Achieves minimal business downtime, 24/7 monitoring, automatic incident ticketing with SLA and escalation rules, and granular projector, audio, and server health visibility.",
    topics: ['IMS', 'IT Operations', 'Alert Management', 'IT Automation', 'IT Operations Teams'],
    type: 'case-studies',
    product: 'Infraon IMS',
    industry: 'Telecommunications / Digital Media',
    name: 'Case Studies',
    url: '/assets/docs/case-study/infraon-suite/suite-airtel-cinema.pdf',
    // icon: '/assets/img/case-study/canara_bank.svg',
    thumbnail: [
      {
        small: '/assets/img/thumbnails/new/case-study/airtel.svg',
        large: '/assets/img/thumbnails/new/case-study/airtel.svg',
      },
    ],
    format: 'pdf',
    featured: false,
    downloads: 34,
    preSelected: false,
  },

  // whitepaper
  {
    id: 55,
    slug: 'finops-itam-guide-2025',
    title: 'A Quick Guide to Improving FinOps with ITAM in 2025 FinOps',
    product: 'Infraon Assets',
    subtitle: 'A Quick Guide to Improving FinOps with ITAM in 2025 FinOps',
    description:
      'Comprehensive guide connecting financial operations with IT asset management practices, demonstrating how integrated ITAM drives cloud cost optimization, budget predictability, and financial accountability. Explores practical frameworks for implementing FinOps methodologies through enhanced asset visibility and cost allocation.',
    topics: ['ITAM', 'Cost Optimization', 'Compliance & Security', 'FinOps', 'IT Leaders & CIOs'],
    type: 'whitepapers',
    name: 'Whitepapers',
    url: '/assets/docs/whitepapers/A-quick-guide-to-improving-FinOps-with-ITAM-in-2025.pdf',
    // icon: '/assets/img/document-thumbnails/finops.webp',
    thumbnail: [
      {
        small: '/assets/img/thumbnails/new/whitepapers/assets.svg',
        large: '/assets/img/thumbnails/new/whitepapers/assets.svg',
      },
    ],
    format: 'pdf',
    featured: false,
    downloads: 342,
    preSelected: true,
    topicTitle: 'Key Topics',
    topicsCovered: [
      'FinOps fundamentals and ITAM synergies',
      'Cloud cost optimization strategies',
      'Budget forecasting with asset data',
      'Chargeback and showback models',
      'ROI measurement frameworks',
    ],
  },
  {
    id: 56,
    slug: 'managing-it-assets-in-hybrid-environments',
    title: 'The Art and Science of Managing IT Assets in Hybrid Environments',
    product: 'Infraon Assets',
    subtitle: 'The Art and Science of Managing IT Assets in Hybrid Environments',
    description:
      'Strategic framework for managing assets across on-premises, cloud, and hybrid infrastructure, addressing visibility challenges, compliance requirements, and cost optimization. Provides actionable methodologies for unified asset tracking, security management, and governance across distributed technology landscapes.',
    topics: [
      'ITAM',
      'Asset Visibility',
      'Cloud Monitoring',
      'Compliance & Security',
      'IT Leaders & CIOs',
      'Enterprise IT',
    ],
    type: 'whitepapers',
    name: 'Whitepapers',
    url: '/assets/docs/whitepapers/The-art-and-science-of-managing-IT-assets-in-hybrid-enviornment.pdf',
    // icon: '/assets/img/document-thumbnails/hybrid-env.webp',
    thumbnail: [
      {
        small: '/assets/img/thumbnails/new/whitepapers/assets.svg',
        large: '/assets/img/thumbnails/new/whitepapers/assets.svg',
      },
    ],
    format: 'pdf',
    featured: false,
    downloads: 0,
    preSelected: true,
    topicTitle: 'Key Topics',
    topicsCovered: [
      'Hybrid infrastructure visibility challenges',
      'Multi-cloud asset management approaches',
      'Security and compliance in hybrid environments',
      'Cost optimization across platforms',
      'Governance and policy frameworks',
    ],
  },

  // webinars
  {
    id: 58,
    slug: 'uae-itops-compliance-playbook-2026',
    title: 'The ITOps Compliance Playbook for UAE Enterprises in 2026 (UAE) ',
    subtitle: 'The ITOps Compliance Playbook for UAE Enterprises in 2026 | Infraon Infinity',
    description:
      'Practical, no-fluff guidance for UAE enterprises navigating compliance audits. Covers UAE ECC evidence collection, CBUAE Technology Risk requirements, ADHICS healthcare IT governance, inspection-ready asset visibility, and unified ITOps control with Infraon Infinity - built for IT teams under regulatory pressure.',
    topics: [
      'AIOps',
      'Alert Management',
      'AI & ML',
      'Observability',
      'IT Operations Teams',
      'IT Leaders & CIOs',
    ],
    type: 'webinars',
    product: 'Infraon AIOps',
    name: 'Webinars',
    url: '6cPk2EcJTqM?si=5YC1J7Q8nCy5TJCF&amp;start=3',
    icon: 'https://img.youtube.com/vi/6cPk2EcJTqM/sddefault.jpg',
    thumbnail: [
      {
        small: 'https://img.youtube.com/vi/6cPk2EcJTqM/sddefault.jpg',
        large: '',
      },
    ],
    format: 'video',
    featured: false,
    downloads: 156,
    preSelected: true,
  },
  {
    id: 59,
    slug: 'introduction-to-aiops',
    title: 'Introduction to AIOps with Infraon',
    subtitle: 'Introduction to AIOps with Infraon | Infraon AIOps',
    description:
      'A live, interactive session demystifying AIOps for IT teams. Covers intelligent event correlation to cut alert noise by up to 90%, anomaly detection, predicting failures before they impact users, and automating incident routing practical guidance for teams evaluating or getting started with AIOps.',
    topics: [
      'AIOps',
      'Alert Management',
      'AI & ML',
      'Observability',
      'IT Operations Teams',
      'IT Leaders & CIOs',
    ],
    type: 'webinars',
    product: 'Infraon AIOps',
    name: 'Webinars',
    url: 'ggSuy1-Hk6o?si=d_0rYN5Gy1kPeg38&amp;start=3',
    icon: 'https://img.youtube.com/vi/ggSuy1-Hk6o/sddefault.jpg',
    thumbnail: [
      {
        small: 'https://img.youtube.com/vi/ggSuy1-Hk6o/sddefault.jpg',
        large: '',
      },
    ],
    format: 'video',
    featured: false,
    downloads: 156,
    preSelected: true,
  },
  {
    id: 60,
    slug: 'transforming-it-asset-management-indonesia',
    title: 'Transforming IT Asset Management in 2026 (Indonesia)',
    subtitle: 'Transforming IT Asset Management in 2026 | ITAM | Infraon Assets',
    description:
      'Discover the future of IT asset management in 2026, including AI-driven automation, sustainability practices, hybrid infrastructure tracking, and cost optimization strategies. Recorded in Bahasa Indonesia - expert insights for IT teams preparing for next-generation ITAM challenges across the region.',
    topics: [
      'ITAM',
      'Asset Visibility',
      'Cost Optimization',
      'Compliance & Security',
      'AI & ML',
      'IT Leaders & CIOs',
      'IT Operations Teams',
    ],
    type: 'webinars',
    product: 'Infraon Assets',
    name: 'Webinars',
    url: 'Nlu5Kpc89S4?si=kd7fmy7Va8FrxQNB&amp;start=4',
    icon: 'https://img.youtube.com/vi/Nlu5Kpc89S4/sddefault.jpg',
    thumbnail: [
      {
        small: 'https://img.youtube.com/vi/Nlu5Kpc89S4/sddefault.jpg',
        large: '',
      },
    ],
    format: 'video',
    featured: false,
    downloads: 156,
    preSelected: true,
  },
  {
    id: 61,
    slug: 'transforming-it-asset-management-2025',
    title: 'Transforming IT Asset Management in 2025',
    subtitle: 'Transforming IT Asset Management in 2025 | ITAM | Infraon Assets',
    description:
      'Discover upcoming trends in IT asset management for 2026, including AI-driven automation, sustainability practices, hybrid infrastructure tracking, and cost optimization strategies. Expert insights on preparing organizations for next-generation ITAM challenges.',
    topics: ['ITAM', 'Asset Visibility', 'Cost Optimization', 'IT Leaders & CIOs'],
    type: 'webinars',
    product: 'Infraon Assets',
    name: 'Webinars',
    url: '72jNzgBTVBU?si=KZGeqrwkMQ-4dpuA&amp;controls=0&amp;start=317',
    // icon: 'https://img.youtube.com/vi/72jNzgBTVBU/sddefault.jpg',
    thumbnail: [
      {
        small: 'https://img.youtube.com/vi/72jNzgBTVBU/sddefault.jpg',
        large: 'https://img.youtube.com/vi/72jNzgBTVBU/sddefault.jpg',
      },
    ],
    format: 'video',
    featured: false,
    downloads: 156,
    preSelected: false,
  },
  {
    id: 62,
    slug: 'itsm-best-practices-2025',
    title: 'ITSM Best Practices for 2025',
    subtitle: 'ITSM Best Practices for 2025 | IT Service Management | Infraon ITSM',
    description:
      'Learn proven strategies for implementing effective IT service management in 2025, improving service quality through ITIL frameworks, leveraging GenAI for automated support, and optimizing workflows for enhanced operational efficiency.',
    topics: [
      'ITSM',
      'IT Automation',
      'Compliance & Security',
      'Service Desk Teams',
      'IT Leaders & CIOs',
    ],
    type: 'webinars',
    product: 'Infraon ITSM',
    name: 'Webinars',
    url: 'KIO8JAxRoCg?si=TvABjPDSM5C9UybJ&amp;controls=0',
    // icon: 'https://img.youtube.com/vi/KIO8JAxRoCg/sddefault.jpg',
    thumbnail: [
      {
        small: 'https://img.youtube.com/vi/KIO8JAxRoCg/sddefault.jpg',
        large: 'https://img.youtube.com/vi/KIO8JAxRoCg/sddefault.jpg',
      },
    ],
    format: 'video',
    featured: false,
    downloads: 0,
    preSelected: false,
  },
  {
    id: 63,
    slug: 'traffic-analysis-for-it-leaders',
    title: 'Traffic Analysis for IT Leaders',
    subtitle:
      'Traffic Analysis for IT Leaders: Smarter Insights, Seamless Networks | IT Service Management | Infraon ITSM',
    description:
      'Expert insights on network traffic analysis, performance optimization, and proactive issue detection for seamless IT operations. Learn to leverage traffic data for capacity planning, security monitoring, and service delivery.',
    topics: [
      'IMS',
      'IT Operations',
      'Traffic Flow Analysis',
      'Alert Management',
      'Observability',
      'IT Leaders & CIOs',
      'IT Operations Teams',
    ],
    type: 'webinars',
    product: 'Infraon ITSM',
    name: 'Webinars',
    url: 'lSHNY61cU_o?si=GjBf2EU_RBE5qQLY&amp;controls=0',
    // icon: 'https://img.youtube.com/vi/lSHNY61cU_o/sddefault.jpg',
    thumbnail: [
      {
        small: 'https://img.youtube.com/vi/lSHNY61cU_o/sddefault.jpg',
        large: 'https://img.youtube.com/vi/lSHNY61cU_o/sddefault.jpg',
      },
    ],
    format: 'video',
    featured: false,
    downloads: 177,
    preSelected: false,
  },
  {
    id: 64,
    slug: 'future-of-itops-ai-automation',
    title: 'The Future of ITOps - AI Automation and a Unified Approach',
    subtitle:
      'The Future of ITOps - AI Automation and a Unified Approach | IT Service Management | Infraon ITSM',
    description:
      'Explore how AI and unified platforms transform IT operations, eliminating tool sprawl and enabling predictive management. Discover strategies for implementing integrated ITOps solutions and leveraging automation for operational excellence.',
    topics: [
      'ITSM',
      'IT Operations',
      'IT Automation',
      'Agentic AI',
      'Intelligent Automation',
      'IT Leaders & CIOs',
      'IT Operations Teams',
    ],
    type: 'webinars',
    product: 'Infraon Infinity',
    name: 'Webinars',
    url: '91RDHhFpUZQ?si=5FmL6_2pGOj4Xq6u&amp;controls=0',
    // icon: 'https://img.youtube.com/vi/91RDHhFpUZQ/sddefault.jpg',
    thumbnail: [
      {
        small: 'https://img.youtube.com/vi/91RDHhFpUZQ/sddefault.jpg',
        large: 'https://img.youtube.com/vi/91RDHhFpUZQ/sddefault.jpg',
      },
    ],
    format: 'video',
    featured: false,
    downloads: 30,
    preSelected: false,
  },

  // presentations
  {
    id: 70,
    slug: 'infraon-infinity',
    title: 'Infraon Infinity',
    product: 'Infraon Infinity',
    subtitle: 'Infraon Infinity',
    description:
      'Comprehensive executive presentation covering Infraon Infinity unified IT operations platform capabilities, business benefits, implementation approach, and ROI analysis. Perfect for stakeholder presentations, demos, and strategic planning sessions.',
    topics: ['ITSM', 'IT Operations', 'IT Automation', 'IT Leaders & CIOs', 'Enterprise IT'],
    type: 'presentations',
    name: 'Presentations',
    url: '/assets/docs/presentation/PPT_Infraon_Infinity.pdf',
    // icon: '/assets/img/document-thumbnails/infinity-ppt-thumbnail.webp',
    thumbnail: [
      {
        small: '/assets/img/thumbnails/new/ppt/infinity.svg',
        large: '/assets/img/thumbnails/new/ppt/infinity.svg',
      },
    ],
    format: 'pdf',
    featured: false,
    downloads: 91,
    preSelected: true,
  },
  {
    id: 71,
    slug: 'infraon-itsm',
    title: 'Infraon ITSM',
    product: 'Infraon ITSM',
    subtitle: 'Infraon ITSM',
    description:
      'Executive overview of Infraon ITSM capabilities, GenAI features, automation benefits, and service management best practices. Includes ITIL 4 certification details, deployment timelines, and customer success metrics.',
    topics: [
      'ITSM',
      'IT Automation',
      'Compliance & Security',
      'Generative AI',
      'IT Leaders & CIOs',
      'Service Desk Teams',
    ],
    type: 'presentations',
    name: 'Presentations',
    url: '/assets/docs/presentation/PPT_Infraon_ITSM.pdf',
    // icon: '/assets/img/document-thumbnails/itsm-ppt-thumbnail.webp',
    thumbnail: [
      {
        small: '/assets/img/thumbnails/new/ppt/itsm.svg',
        large: '/assets/img/thumbnails/new/ppt/itsm.svg',
      },
    ],
    format: 'pdf',
    featured: false,
    downloads: 733,
    preSelected: true,
  },
  {
    id: 72,
    slug: 'infraon-assets',
    title: 'Infraon Assets',
    product: 'Infraon Assets',
    subtitle: 'Infraon Assets',
    description:
      'Strategic presentation on IT asset management transformation, cost optimization opportunities, compliance automation, and operational efficiency gains. Features ROI calculators, implementation roadmap, and industry-specific use cases.',
    topics: [
      'ITAM',
      'Asset Visibility',
      'Cost Optimization',
      'Compliance & Security',
      'IT Leaders & CIOs',
      'Enterprise IT',
    ],
    type: 'presentations',
    name: 'Presentations',
    url: '/assets/docs/presentation/PPT_Infraon_Assets.pdf',
    // icon: '/assets/img/document-thumbnails/assets-ppt-thumbnail.webp',
    thumbnail: [
      {
        small: '/assets/img/thumbnails/new/ppt/assets.svg',
        large: '/assets/img/thumbnails/new/ppt/assets.svg',
      },
    ],
    format: 'pdf',
    featured: false,
    downloads: 452,
    preSelected: true,
  },

  // free resources
  {
    id: 73,
    slug: 'time-and-cost-saving-calculator',
    title: 'Time and Cost Saving Calculator',
    product: 'Infraon Assets',
    subtitle: 'Time and Cost Saving Calculator | ITAM | Infraon Assets',
    description: 'Calculate ITAM ROI and Efficiency Gains',
    topics: ['ITAM', 'Cost Optimization', 'FinOps', 'IT Leaders & CIOs'],
    type: 'free-resources',
    name: 'Free Resources',
    url: '"/assets/docs/excel/ITAM%20Time%20and%20Cost%20Savings%20Calculator.xlsx',
    // icon: '/assets/img/document-thumbnails/cost-saving-calculator.svg',
    thumbnail: [
      {
        small: '/assets/img/document-thumbnails/cost-saving-calculator.svg',
        large: '/assets/img/document-thumbnails/cost-saving-calculator.svg',
      },
    ],
    format: 'xlsx',
    featured: false,
    downloads: 1234,
    preSelected: true,
    topicTitle: "What You'll Calculate",
    topicsCovered: [
      'Current vs. automated time spent',
      'Manual labor cost savings',
      'License cost optimization potential',
      'Productivity improvement metrics',
      'Total ROI projection',
    ],
  },
  {
    id: 74,
    slug: 'streamlined-itam-time-savings-calculator',
    title: 'Calculator on Time Savings of Streamlined ITAM',
    product: 'Infraon Assets',
    subtitle: 'Calculator on Time savings of streamlined ITAM(Introduction) | Infraon Assets',
    description: 'Measure Efficiency from Streamlined Processes',
    topics: ['ITAM', 'Cost Optimization', 'FinOps', 'IT Leaders & CIOs'],
    type: 'free-resources',
    name: 'Free Resources',
    url: '/assets/docs/excel/Calculator%20on%20Time%20savings%20of%20streamlined%20ITAM(Introduction).csv',
    // icon: '/assets/img/document-thumbnails/time-saving-calculator.svg',
    thumbnail: [
      {
        small: '/assets/img/document-thumbnails/time-saving-calculator.svg',
        large: '/assets/img/document-thumbnails/time-saving-calculator.svg',
      },
    ],
    format: 'csv',
    featured: false,
    downloads: 567,
    preSelected: true,
    topicTitle: "What You'll Calculate",
    topicsCovered: [
      'Discovery time reduction',
      'Tracking efficiency gains',
      'Reporting time savings',
      'Compliance preparation time',
      'Monthly/annual time saved',
    ],
  },
  {
    id: 75,
    slug: 'green-friendly-itam-practices',
    title: 'Emergence of Green Friendly ITAM Practices',
    product: 'Infraon Assets',
    subtitle: 'Emergence of Green Friendly ITAM Practices (Instructions) | Infraon Assets',
    description: 'Sustainable IT Asset Management Guide',
    topics: ['ITAM', 'Compliance & Security', 'IT Leaders & CIOs'],
    type: 'free-resources',
    name: 'Free Resources',
    url: '/assets/docs/excel/Emergence of Green Friendly ITAM Practices(Instructions).xlsx',
    // icon: '/assets/img/document-thumbnails/green-friendly-itam-practice.svg',
    thumbnail: [
      {
        small: '/assets/img/document-thumbnails/green-friendly-itam-practice.svg',
        large: '/assets/img/document-thumbnails/green-friendly-itam-practice.svg',
      },
    ],
    format: 'xlsx',
    featured: false,
    downloads: 0,
    preSelected: true,
    topicTitle: 'Guide Contents',
    topicsCovered: [
      'Sustainable ITAM principles',
      'E-waste reduction strategies',
      'Resource optimization techniques',
      'Environmental compliance frameworks',
      'Green certification preparation',
      'Implementation checklists',
    ],
  },
  {
    id: 76,
    slug: 'itam-time-and-cost-saving-calculator-instructions',
    title: 'ITAM Time and Cost Savings Calculator (Instructions)',
    product: 'Infraon Assets',
    subtitle: 'ITAM Time and Cost Savings Calculator (Instructions) | Infraon Assets',
    description: 'Complete ROI Calculation with Instructions',
    topics: ['ITAM', 'Cost Optimization', 'FinOps', 'IT Leaders & CIOs'],
    type: 'free-resources',
    name: 'Free Resources',
    url: '/assets/docs/excel/ITAM Time and Cost Savings Calculator(Instructions).xlsx',
    // icon: '/assets/img/document-thumbnails/cost-and-time-saving-calculator.webp',
    thumbnail: [
      {
        small: '/assets/img/document-thumbnails/cost-and-time-saving-calculator.webp',
        large: '/assets/img/document-thumbnails/cost-and-time-saving-calculator.webp',
      },
    ],
    format: 'xlsx',
    featured: false,
    downloads: 0,
    preSelected: true,
    topicTitle: 'Documentation Includes',
    topicsCovered: [
      'Calculator methodology',
      'Formula explanations',
      'Input field guidelines',
      'Interpretation framework',
      'Benchmark data',
      'Case study examples',
    ],
  },
  {
    id: 77,
    slug: 'it-budget-template',
    title: 'IT Budget Template',
    product: 'Infraon Assets',
    subtitle: 'IT Budget Template | Infraon Assets',
    description: 'Comprehensive IT Budget Planning Tool',
    topics: ['ITAM', 'Cost Optimization', 'FinOps', 'IT Leaders & CIOs'],
    type: 'free-resources',
    name: 'Free Resources',
    url: '/assets/docs/excel/IT Budget Template Updated(Instructions).xlsx',
    // icon: '/assets/img/document-thumbnails/it-budget-templating-calculator.svg',
    thumbnail: [
      {
        small: '/assets/img/document-thumbnails/it-budget-templating-calculator.svg',
        large: '/assets/img/document-thumbnails/it-budget-templating-calculator.svg',
      },
    ],
    format: 'xlsx',
    featured: false,
    downloads: 0,
    preSelected: true,
    topicTitle: 'Template Features',
    topicsCovered: [
      'Hardware budget planning',
      'Software licensing tracking',
      'Cloud services costs',
      'Personnel allocation',
      'Operational expenses',
      'Automated calculations',
      'Variance analysis',
      'Monthly/quarterly/annual views',
    ],
  },

  // press and media
  {
    id: 78,
    slug: 'infraon-helpdesk-gen-ai-human-collaboration',
    title: 'Infraon Helpdesk increases Gen AI-Human collaboration to boost service efficiency',
    product: 'Infraon Assets',
    subtitle: 'Infraon Helpdesk increases Gen AI-Human collaboration to boost service efficiency',
    description:
      'Infraon announces GenAI capabilities in the Helpdesk solution, enabling enhanced human-AI collaboration for improved service efficiency. Features include automated ticket resolution, intelligent routing, and conversational AI support.',
    topics: ['ITSM', 'Generative AI', 'AI & ML', 'Service Desk Teams'],
    type: 'press-n-medias',
    name: 'Press and Medias',
    url: 'https://newswirejet.com/press-releases/infraon-helpdesk-increases-gen-ai-human-collaboration-to-boost-service-efficiency/',
    // icon: '/assets/img/document-thumbnails/pr/ai-vs-it-outages-business-news-week.webp',
    thumbnail: [
      {
        small:
          '/assets/img/thumbnails/new/pr/infraon-helpdesk-increases-gen-ai-human-collaboration-to-boost-service-efficiency.webp',
        large:
          '/assets/img/thumbnails/new/pr/infraon-helpdesk-increases-gen-ai-human-collaboration-to-boost-service-efficiency.webp',
      },
    ],
    format: 'hyperlink',
    featured: false,
    downloads: 11,
    preSelected: true,
    publicationDate: 'Nov 13, 2023',
  },
  {
    id: 79,
    slug: 'infraon-itam-cost-and-time-savings',
    title: 'Infraon offers ITAM solutions to enable high cost and time savings',
    product: 'Infraon Assets',
    subtitle: 'Infraon offers ITAM solutions to enable high cost and time savings',
    description:
      'Infraon launches enhanced IT Asset Management solutions delivering high cost and time savings through automated discovery, license optimization, and compliance tracking. Real-world case studies demonstrate 50-75% productivity improvements.',
    topics: ['ITAM', 'Cost Optimization', 'Asset Visibility', 'IT Leaders & CIOs'],
    type: 'press-n-medias',
    name: 'Press and Medias',
    url: 'https://newswirejet.com/press-releases/infraon-offers-itam-solutions-to-enable-significant-cost-and-time-savings/',
    // icon: '/assets/img/document-thumbnails/pr/ai-vs-it-outages-business-news-week.webp',
    thumbnail: [
      {
        small:
          '/assets/img/thumbnails/new/pr/infraon-offers-itam-solutions-to-enable-significant-cost-and-time-savings.webp',
        large:
          '/assets/img/thumbnails/new/pr/infraon-offers-itam-solutions-to-enable-significant-cost-and-time-savings.webp',
      },
    ],
    format: 'hyperlink',
    featured: false,
    downloads: 11,
    preSelected: true,
    publicationDate: 'Oct 30, 2023',
  },
  {
    id: 80,
    slug: 'infraon-saas-itam-software-roi',
    title:
      'Infraon offers SaaS-based asset management tool to help enterprises maximize software ROI',
    product: 'Infraon Assets',
    subtitle:
      'Infraon offers SaaS-based asset management tool to help enterprises maximize software ROI',
    description:
      'New SaaS-based asset management platform helps enterprises maximize software ROI through intelligent license tracking, usage analytics, and optimization recommendations. The platform delivers 30% average cost reduction.',
    topics: ['ITAM', 'Cost Optimization', 'Asset Visibility', 'IT Leaders & CIOs'],
    type: 'press-n-medias',
    name: 'Press and Medias',
    url: 'https://newswirejet.com/press-releases/infraon-offers-saas-based-asset-management-tool-to-help-enterprises-maximize-software-roi/',
    // icon: '/assets/img/document-thumbnails/pr/et-news-cover.webp',
    thumbnail: [
      {
        small:
          '/assets/img/thumbnails/new/pr/infraon-offers-saas-based-asset-management-tool-to-help-enterprises-maximize-software-roi.svg',
        large:
          '/assets/img/thumbnails/new/pr/infraon-offers-saas-based-asset-management-tool-to-help-enterprises-maximize-software-roi.svg',
      },
    ],
    format: 'hyperlink',
    featured: false,
    downloads: 2343,
    preSelected: true,
    publicationDate: 'Sep 02, 2023',
  },
  {
    id: 81,
    slug: 'infraon-dex-platform',
    title: "Infraon's DEX to help companies build a powerful culture of innovation",
    product: 'Infraon Infinity',
    subtitle: "Infraon's DEX to help companies build a powerful culture of innovation",
    description:
      'Infraon announces a Digital Employee Experience (DEX) platform helping companies build an innovation culture through enhanced employee technology experiences, proactive support, and performance optimization capabilities.',
    topics: ['IT Operations', 'Enterprise IT'],
    type: 'press-n-medias',
    name: 'Press and Medias',
    url: 'https://newswirejet.com/press-releases/infraons-dex-to-help-companies-build-a-powerful-culture-of-innovation/"',
    // icon: '/assets/img/document-thumbnails/pr/sme-channel-cover.webp',
    thumbnail: [
      {
        small:
          '/assets/img/thumbnails/new/pr/infraons-dex-to-help-companies-build-a-powerful-culture-of-innovation.webp',
        large:
          '/assets/img/thumbnails/new/pr/infraons-dex-to-help-companies-build-a-powerful-culture-of-innovation.webp',
      },
    ],
    format: 'hyperlink',
    featured: false,
    downloads: 456,
    preSelected: true,
    publicationDate: 'June 06, 2023',
  },
  {
    id: 82,
    slug: 'infraon-itsm-ai-platform',
    title: "Infraon's ITSM platform to help enterprises unlock the power of AI",
    product: 'Infraon ITSM',
    subtitle: "Infraon's ITSM platform to help enterprises unlock the power of AI",
    description:
      'Infraon ITSM platform integrates AI capabilities, enabling enterprises to unlock automation potential, improve service quality, and accelerate resolution times through intelligent workflows and predictive analytics.',
    topics: ['ITSM', 'IT Automation', 'Generative AI', 'AI & ML', 'IT Leaders & CIOs'],
    type: 'press-n-medias',
    name: 'Press and Medias',
    url: 'https://newswirejet.com/press-releases/infraons-itsm-platform-to-help-enterprises-unlock-the-power-of-ai/',
    // icon: '/assets/img/document-thumbnails/pr/raise-of-agentic-ai.png',
    thumbnail: [
      {
        small:
          '/assets/img/thumbnails/new/pr/infraons-itsm-platform-to-help-enterprises-unlock-the-power-of-ai.webp',
        large:
          '/assets/img/thumbnails/new/pr/infraons-itsm-platform-to-help-enterprises-unlock-the-power-of-ai.webp',
      },
    ],
    format: 'hyperlink',
    featured: false,
    downloads: 0,
    preSelected: true,
    publicationDate: 'June 06, 2023',
  },
  {
    id: 83,
    slug: 'infraon-digital-employee-experience',
    title:
      'Infraon Corp will soon launch a SaaS-based and fully integrated Digital Employee Experience (DEX) platform',
    product: 'Infraon Infinity',
    subtitle:
      'Infraon Corp will soon launch a SaaS-based and fully integrated Digital Employee Experience (DEX) platform',
    description:
      'Infraon announces the upcoming launch of a SaaS-based Digital Employee Experience platform delivering a fully integrated employee technology experience management, proactive monitoring, and AI-powered support capabilities.',
    topics: ['IT Operations', 'Enterprise IT'],
    type: 'press-n-medias',
    name: 'Press and Medias',
    url: 'https://newswirejet.com/press-releases/infraon-corp-will-soon-launch-a-saas-based-and-fully-integrated-digital-employee-experience-dex-platform/',
    // icon: '/assets/img/document-thumbnails/pr/rewriting-technology-ai-biz-news-daily.png',
    thumbnail: [
      {
        small:
          '/assets/img/thumbnails/new/pr/infraon-corp-will-soon-launch-a-saas-based-and-fully-integrated-digital-employee-experience-dex-platform.webp',
        large:
          '/assets/img/thumbnails/new/pr/infraon-corp-will-soon-launch-a-saas-based-and-fully-integrated-digital-employee-experience-dex-platform.webp',
      },
    ],
    format: 'hyperlink',
    featured: false,
    downloads: 123,
    preSelected: true,
    publicationDate: 'June 04, 2023',
  },
  {
    id: 84,
    slug: 'infraon-saas-suite-recession-itops',
    title:
      "Infraon's SaaS-based product suite helps companies overcome their biggest recession-related ITOps issues",
    product: 'Infraon Infinity',
    subtitle:
      "Infraon's SaaS-based product suite helps companies overcome their biggest recession-related ITOps issues",
    description:
      "Infraon's integrated SaaS product suite helps organizations overcome recession-related IT operations challenges through cost optimization, tool consolidation, and operational efficiency improvements during economic uncertainty.",
    topics: ['IT Operations', 'Cost Optimization', 'IT Leaders & CIOs', 'Enterprise IT'],
    type: 'press-n-medias',
    name: 'Press and Medias',
    url: 'https://newswirejet.com/press-releases/infraons-saas-based-product-suite-helps-companies-overcome-their-biggest-recession-related-itops-issues/',
    // icon: '/assets/img/document-thumbnails/pr/rewriting-technology-ai-biz-news-daily.png',
    thumbnail: [
      {
        small:
          '/assets/img/thumbnails/new/pr/infraons-saas-based-product-suite-helps-companies-overcome-their-biggest-recession-related-itops-issues.webp',
        large:
          '/assets/img/thumbnails/new/pr/infraons-saas-based-product-suite-helps-companies-overcome-their-biggest-recession-related-itops-issues.webp',
      },
    ],
    format: 'hyperlink',
    featured: false,
    downloads: 123,
    preSelected: true,
    publicationDate: 'June 04, 2023',
  },
  {
    id: 85,
    slug: 'infraon-saas-itsm-ai',
    title:
      "Infraon's SaaS-based, fully integrated ITSM platform helps service teams unlock the true power of AI",
    product: 'Infraon ITSM',
    subtitle:
      "Infraon's SaaS-based, fully integrated ITSM platform helps service teams unlock the true power of AI",
    description:
      'Integrated ITSM platform helps service teams leverage AI capabilities for automated resolution, predictive analytics, and intelligent workflows. The platform delivers measurable improvements in service quality and efficiency.',
    topics: ['ITSM', 'IT Automation', 'Generative AI', 'AI & ML', 'Service Desk Teams'],
    type: 'press-n-medias',
    name: 'Press and Medias',
    url: 'https://newswirejet.com/press-releases/infraons-saas-based-fully-integrated-itsm-platform-helps-service-teams-unlock-the-true-power-of-ai/',
    // icon: '/assets/img/document-thumbnails/pr/rewriting-technology-ai-biz-news-daily.png',
    thumbnail: [
      {
        small:
          '/assets/img/thumbnails/new/pr/infraons-saas-based-fully-integrated-itsm-platform-helps-service-teams-unlock-the-true-power-of-ai.webp',
        large:
          '/assets/img/thumbnails/new/pr/infraons-saas-based-fully-integrated-itsm-platform-helps-service-teams-unlock-the-true-power-of-ai.webp',
      },
    ],
    format: 'hyperlink',
    featured: false,
    downloads: 123,
    preSelected: true,
    publicationDate: 'June 04, 2023',
  },
  {
    id: 86,
    slug: 'itops-technology-trends-2023',
    title: '5 technology trends that ITOps managers and leaders should watch out for in 2023',
    product: 'Infraon Infinity',
    subtitle: '5 technology trends that ITOps managers and leaders should watch out for in 2023',
    description:
      'Thought leadership article identifying five critical technology trends for IT operations leaders, including AIOps adoption, unified platforms, automation acceleration, cloud optimization, and security integration.',
    topics: ['AIOps', 'IT Operations', 'IT Automation', 'AI & ML', 'IT Leaders & CIOs'],
    type: 'press-n-medias',
    name: 'Press and Medias',
    url: 'https://newswirejet.com/press-releases/5-technology-trends-that-itops-managers-and-leaders-should-watch-out-for-in-2023/',
    // icon: '/assets/img/document-thumbnails/pr/rewriting-technology-ai-biz-news-daily.png',
    thumbnail: [
      {
        small:
          '/assets/img/thumbnails/new/pr/5-technology-trends-that-itops-managers-and-leaders-should-watch-out-for-in-2023.webp',
        large:
          '/assets/img/thumbnails/new/pr/5-technology-trends-that-itops-managers-and-leaders-should-watch-out-for-in-2023.webp',
      },
    ],
    format: 'hyperlink',
    featured: false,
    downloads: 123,
    preSelected: true,
    publicationDate: 'Janurary 30, 2023',
  },
  {
    id: 87,
    slug: 'infraon-launches-saas-product-suite',
    title:
      'Infraon launches a fully integrated, SaaS-based product suite to control and commit to IT Operations modernization',
    product: 'Infraon Infinity',
    subtitle:
      'Infraon launches a fully integrated, SaaS-based product suite to control and commit to IT Operations modernization',
    description:
      'Infraon announces the launch of a fully integrated SaaS-based product suite for IT operations modernization, combining ITSM, ITAM, monitoring, and automation in a unified platform, eliminating tool sprawl.',
    topics: ['IT Operations', 'Cost Optimization', 'IT Automation', 'Enterprise IT'],
    type: 'press-n-medias',
    name: 'Press and Medias',
    url: 'https://newswirejet.com/press-releases/infraon-launches-a-fully-integrated-saas-based-product-suite-to-control-and-commit-to-it-operations-modernization/',
    // icon: '/assets/img/document-thumbnails/pr/rewriting-technology-ai-biz-news-daily.png',
    thumbnail: [
      {
        small:
          '/assets/img/thumbnails/new/pr/infraon-launches-a-fully-integrated-saas-based-product-suite-to-control-and-commit-to-it-operations-modernization.webp',
        large:
          '/assets/img/thumbnails/new/pr/infraon-launches-a-fully-integrated-saas-based-product-suite-to-control-and-commit-to-it-operations-modernization.webp',
      },
    ],
    format: 'hyperlink',
    featured: false,
    downloads: 123,
    preSelected: true,
    publicationDate: 'December 04, 2023',
  },

  // ebook
  {
    id: 88,
    slug: 'future-of-itam-2026',
    title: 'The Future of ITAM: Trends and Predictions for 2026',
    product: 'Infraon Assets',
    subtitle: 'Stay Ahead of the ITAM Curve in 2026',
    description:
      'Explore the future of IT asset management with actionable trends, emerging technologies, and proven strategies for 2026. From automated compliance to cloud-based asset discovery, learn how to drive business value and digital transformation through smarter ITAM practices.',
    topics: [
      'ITAM',
      'Asset Visibility',
      'Cost Optimization',
      'Compliance & Security',
      'Emerging Tech',
      'IT Leaders & CIOs',
    ],
    type: 'ebook',
    name: 'E-Book',
    url: '/assets/docs/ITAM-Ebook.pdf',
    // icon: '/assets/img/document-thumbnails/ebook-1.png',
    thumbnail: [
      {
        small: '/assets/img/thumbnails/new/e-books/assets-small.png',
        large: '/assets/img/thumbnails/new/e-books/assets.png',
      },
    ],
    format: 'hyperlink',
    featured: false,
    downloads: 0,
    preSelected: true,
    topicTitle: 'Topics Covered',
    topicsCovered: [
      'ITAM trends shaping 2026',
      'Emerging technologies and their use cases in ITAM',
      'Strategies for the next digital frontier',
      'Best practices to implement ITAM in 2026',
    ],
  },
  {
    id: 89,
    slug: 'aiops-modernization-journeys',
    title: 'How AIOps Can Fuel Modernization Journeys of Enterprises',
    product: 'Infraon AIOps',
    subtitle: 'AI-Driven IT Operations for the Modern Enterprise',
    description:
      'Discover how AIOps transforms traditional IT operations through predictive analytics, anomaly detection, and intelligent event management. Learn how enterprises and MSPs are leveraging AI-driven insights to reduce downtime, cut costs, and accelerate digital modernization.',
    topics: [
      'AIOps',
      'Alert Management',
      'AI & ML',
      'Intelligent Automation',
      'Observability',
      'IT Leaders & CIOs',
      'IT Operations Teams',
    ],
    type: 'ebook',
    name: 'E-Book',
    url: '/assets/docs/aiops-ebook.pdf',
    // icon: '/assets/img/document-thumbnails/ebook-2.png',
    thumbnail: [
      {
        small: '/assets/img/thumbnails/new/e-books/aiops-small.png',
        large: '/assets/img/thumbnails/new/e-books/aiops.png',
      },
    ],
    format: 'hyperlink',
    featured: false,
    downloads: 0,
    preSelected: true,
    topicTitle: 'Topics Covered',
    topicsCovered: [
      'Why AIOps is vital to modern IT operations',
      'The role of AIOps in transforming IT operations',
      'Beyond core features: empowering modernization with AIOps',
    ],
  },
  {
    id: 90,
    slug: 'future-of-customer-experience',
    title: 'The Future of Customer Experience',
    product: 'Infraon ITSM',
    subtitle: 'A Complete Guide for Maximizing Personalization through MSPs in 2030',
    description:
      'Explore how Managed Service Providers (MSPs) will redefine customer experience by 2030 through advanced personalization, AI-driven insights, and data-led strategies. This guide covers emerging trends, technologies, and actionable approaches businesses can adopt to deliver highly tailored, seamless, and scalable customer interactions.',
    topics: [
      'ITSM',
      'IT Leaders & CIOs',
      'Marketing Automation',
      'Digital Transformation',
      'Workflow Automation',
    ],
    type: 'ebook',
    name: 'E-Book',
    url: '/assets/docs/The-future-of-CX-Maximizing-Personalization-through-MSPs-in-2030.pdf',
    // icon: '/assets/img/document-thumbnails/ebook-3.png',
    thumbnail: [
      {
        small: '/assets/img/thumbnails/new/e-books/itsm-small.png',
        large: '/assets/img/thumbnails/new/e-books/itsm.png',
      },
    ],
    format: 'hyperlink',
    featured: false,
    downloads: 0,
    preSelected: true,
    topicTitle: 'Topics Covered',
    topicsCovered: [
      'Customer Experience (CX)',
      'Managed Service Providers (MSPs)',
      'Remote Monitoring & Management',
      'Professional Services Automation (PSA)',
    ],
  },

  {
    id: 95,
    slug: 'generative-ai-in-itsm-guide',
    title: 'The A to Z Guide to Understand the Role of Generative AI in ITSM',
    product: 'Infraon ITSM',
    subtitle:
      'A quick overview of how generative AI is transforming ITSM with automation and smarter operations.',
    description:
      'The journey to generative AI began with rule-based systems. These systems operated on explicitly defined rules and logic. While effective for specific tasks, their deterministic nature made them rigid and limited in handling complex or unforeseen situations.',
    topics: [
      'ITSM',
      'IT Operations',
      'AI & ML',
      'IT Operations Teams',
      'IT Leaders & CIOs',
      'Generative AI',
    ],
    type: 'ebook',
    name: 'E-Book',
    url: '/assets/docs/The-A-to-Z-Guide-to-Understand-the-Role-of-Generative-AI-in-ITSM.pdf',
    // icon: '/assets/img/document-thumbnails/ebook-4.png',
    thumbnail: [
      {
        small: '/assets/img/thumbnails/new/e-books/itsm-small.png',
        large: '/assets/img/thumbnails/new/e-books/itsm.png',
      },
    ],
    format: 'hyperlink',
    featured: false,
    downloads: 0,
    preSelected: true,
    topicTitle: 'Topics Covered',
    topicsCovered: [
      'Introduction to network management for ISPs',
      'Challenges faced by ISPs and how to overcome them',
      'How network management can optimize ISP processes',
      'Best network management practices for ISPs',
    ],
  },

  //new webinars 2026
  {
    id: 96,
    slug: 'predict-prevent-perform-aiops',
    title: 'Predict, Prevent, Perform: How AIOps Makes IT Ops Smoother',
    product: 'Infraon AIOps',
    subtitle: 'Predict, Prevent, Perform: How AIOps Makes IT Ops Smoother | Infraon AIOps',
    description:
      'Understand how AIOps reduces alert noise from 10,000+ to 200 actionable incidents, predicts failures 2-4 weeks in advance, and automates remediation for resilient IT infrastructure through machine learning.',
    topics: [
      'AIOps',
      'Alert Management',
      'Observability',
      'AI & ML',
      'IT Leaders & CIOs',
      'IT Operations Teams',
    ],
    type: 'webinars',
    name: 'Webinars',
    url: 'BgqrWefdSM4?si=m28YfTjzZbqKdT8W&amp;controls=0',
    icon: 'https://img.youtube.com/vi/BgqrWefdSM4/sddefault.jpg',
    thumbnail: [
      {
        small: 'https://img.youtube.com/vi/BgqrWefdSM4/sddefault.jpg',
        large: 'https://img.youtube.com/vi/BgqrWefdSM4/sddefault.jpg',
      },
    ],
    format: 'video',
    featured: false,
    downloads: 0,
    preSelected: false,
  },

  {
    id: 97,
    slug: 'infraon-oss',
    title: 'Infraon OSS',
    subtitle:
      'A single modular customer-centric OSS platform by EverestIMS for Telecos and Enterrises',
    description:
      'Infraon OSS ensures seamless management of hybrid, transport, fiber, IP and wireless networks. Optimizing infrastructure, automating operations, and monetizing services becomes easy, thereby empowering service providers to be more agile.',
    topics: ['OSS', 'Telecommunications'],
    type: 'datasheet',
    product: 'Infraon OSS',
    name: 'Datasheet',
    url: '/assets/docs/datasheet/OSS_Datasheet.pdf',
    // icon: '/assets/img/case-study/cesc.svg',
    thumbnail: [
      {
        small: '/assets/img/thumbnails/new/datasheets/oss-datasheet.svg',
        large: '/assets/img/thumbnails/new/datasheets/oss-datasheet.svg',
      },
    ],
    format: 'pdf',
    featured: true,
    downloads: 21,
    preSelected: true,
  },
];
